"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9395],{

/***/ 69395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pool; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-currency-input-field/dist/index.esm.js
var index_esm = __webpack_require__(50246);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(37946);
;// CONCATENATED MODULE: ./public/bxs_image-add.svg
var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgBxsImageAdd = function SvgBxsImageAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.127 9.188 2.067-2.75L11.26 9.53V8.5h2.755V3.687c0-.758-.617-1.374-1.377-1.374H3.683c-.76 0-1.377.616-1.377 1.374v8.25c0 .759.618 1.376 1.377 1.376h5.51v-2.75h-4.82l2.066-2.75.688 1.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.015 9.875h-1.377v2.063H10.57v1.374h2.067v2.063h1.377v-2.063h2.067v-1.374h-2.067V9.874Z"
  }))));
};

/* harmony default export */ var bxs_image_add = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxOCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImJ4czppbWFnZS1hZGQiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNy4xMjczMiA5LjE4NzVMOS4xOTM3NCA2LjQzNzVMMTEuMjYwMiA5LjUzMTI1VjguNUgxNC4wMTU0VjMuNjg3NUMxNC4wMTU0IDIuOTI5MTkgMTMuMzk3NSAyLjMxMjUgMTIuNjM3OCAyLjMxMjVIMy42ODMyOEMyLjkyMzUyIDIuMzEyNSAyLjMwNTY2IDIuOTI5MTkgMi4zMDU2NiAzLjY4NzVWMTEuOTM3NUMyLjMwNTY2IDEyLjY5NTggMi45MjM1MiAxMy4zMTI1IDMuNjgzMjggMTMuMzEyNUg5LjE5Mzc0VjEwLjU2MjVINC4zNzIwOUw2LjQzODUxIDcuODEyNUw3LjEyNzMyIDkuMTg3NVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGlkPSJWZWN0b3JfMiIgZD0iTTE0LjAxNTMgOS44NzVIMTIuNjM3N1YxMS45Mzc1SDEwLjU3MTNWMTMuMzEyNUgxMi42Mzc3VjE1LjM3NUgxNC4wMTUzVjEzLjMxMjVIMTYuMDgxN1YxMS45Mzc1SDE0LjAxNTNWOS44NzVaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+Cjwvc3ZnPgo=");
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(13274);
;// CONCATENATED MODULE: ./components/InsertImageButton.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 12px 25px;\n  background-color: #174f68;\n  font-family: 'Nunito';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  outline: none;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n\n  & > div:first-child {\n    width: 35px;\n    height: 35px;\n    margin-right: 1rem;\n  }\n\n  & > div:last-child {\n    margin-left: 1rem;\n  }\n\n  @media (max-width: 768px) {\n    & > div:first-child {\n      width: 18px;\n      height: 18px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Nunito';\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 24px;\n  text-align: center;\n  color: ",
        ";\n  white-space: pre-wrap;\n\n  @media (max-width: 768px) {\n    font-size: 14px;\n  }\n  ",
        " {\n    display: none !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var InsertImageButton = function(_param) {
    var label = _param.label, arrowPosition = _param.arrowPosition, onClick = _param.onClick, args = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "arrowPosition",
        "onClick"
    ]);
    var arrowComponents = {
        down: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaArrowDown */.NWQ, {}),
        up: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaArrowUp */.ZTc, {}),
        left: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaArrowLeft */.x_l, {}),
        right: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaArrowRight */.Z1Y, {}),
        none: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
        onClick: function() {
            return onClick === null || onClick === void 0 ? void 0 : onClick();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "responsive",
                    src: bxs_image_add,
                    alt: "add-image",
                    height: 24,
                    width: 24
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                    children: label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: arrowPosition && arrowComponents[arrowPosition]
            })
        ]
    }));
};
var Container = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-fe3af6c6-0"
})(_templateObject());
var Label = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    componentId: "sc-fe3af6c6-1"
})(_templateObject1(), function(param) {
    var color = param.color;
    return color;
}, (0,media/* media */.B)("<=tablet"));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/short-unique-id/dist/short-unique-id.js
var short_unique_id = __webpack_require__(77913);
var short_unique_id_default = /*#__PURE__*/__webpack_require__.n(short_unique_id);
// EXTERNAL MODULE: ./contexts/Loader.tsx
var Loader = __webpack_require__(41068);
// EXTERNAL MODULE: ./contexts/ReCAPTCHAContext.tsx
var ReCAPTCHAContext = __webpack_require__(84114);
// EXTERNAL MODULE: ./services/apiClient.ts
var apiClient = __webpack_require__(81372);
;// CONCATENATED MODULE: ./utils/colors.ts
var colors = [
    "#4D4D4D",
    "#999999",
    "#FFFFFF",
    "#F44E3B",
    "#FE9200",
    "#FCDC00",
    "#DBDF00",
    "#A4DD00",
    "#68CCCA",
    "#73D8FF",
    "#AEA1FF",
    "#FDA1FF",
    "#333333",
    "#808080",
    "#cccccc",
    "#D33115",
    "#E27300",
    "#FCC400",
    "#B0BC00",
    "#68BC00",
    "#16A5A5",
    "#009CE0",
    "#7B64FF",
    "#FA28FF",
    "#000000",
    "#666666",
    "#B3B3B3",
    "#9F0500",
    "#C45100",
    "#FB9E00",
    "#808900",
    "#194D33",
    "#0C797D",
    "#0062B1",
    "#653294",
    "#AB149E", 
];
var similarityThreshold = 50;
// Função para calcular a distância euclidiana entre duas cores RGB
function getColorDistance(color1, color2) {
    var rDiff = color1.r - color2.r;
    var gDiff = color1.g - color2.g;
    var bDiff = color1.b - color2.b;
    return Math.sqrt(rDiff * rDiff + gDiff * gDiff + bDiff * bDiff);
}
// Função para calcular a distância euclidiana entre duas cores RGB
function hexToRgb(hex) {
    // Converte o valor hex em uma string sem o '#'
    hex = hex.replace("#", "");
    // Extrai os valores de vermelho, verde e azul (cada um com 2 caracteres)
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    // Retorna os valores em um objeto com as propriedades r, g e b
    return {
        r: r,
        g: g,
        b: b
    };
}

;// CONCATENATED MODULE: ./templates/pool/state.ts














var randomUUID = new (short_unique_id_default())({
    length: 10
}).randomUUID;
var states = [
    {
        label: "Acre",
        value: "AC"
    },
    {
        label: "Alagoas",
        value: "AL"
    },
    {
        label: "Amap\xe1",
        value: "AP"
    },
    {
        label: "Amazonas",
        value: "AM"
    },
    {
        label: "Bahia",
        value: "BA"
    },
    {
        label: "Cear\xe1",
        value: "CE"
    },
    {
        label: "Distrito Federal",
        value: "DF"
    },
    {
        label: "Esp\xedrito Santo",
        value: "ES"
    },
    {
        label: "Goi\xe1s",
        value: "GO"
    },
    {
        label: "Maranh\xe3o",
        value: "MA"
    },
    {
        label: "Mato Grosso",
        value: "MT"
    },
    {
        label: "Mato Grosso do Sul",
        value: "MS"
    },
    {
        label: "Minas Gerais",
        value: "MG"
    },
    {
        label: "Par\xe1",
        value: "PA"
    },
    {
        label: "Para\xedba",
        value: "PB"
    },
    {
        label: "Paran\xe1",
        value: "PR"
    },
    {
        label: "Pernambuco",
        value: "PE"
    },
    {
        label: "Piau\xed",
        value: "PI"
    },
    {
        label: "Rio de Janeiro",
        value: "RJ"
    },
    {
        label: "Rio Grande do Norte",
        value: "RN"
    },
    {
        label: "Rio Grande do Sul",
        value: "RS"
    },
    {
        label: "Rond\xf4nia",
        value: "RO"
    },
    {
        label: "Roraima",
        value: "RR"
    },
    {
        label: "Santa Catarina",
        value: "SC"
    },
    {
        label: "S\xe3o Paulo",
        value: "SP"
    },
    {
        label: "Sergipe",
        value: "SE"
    },
    {
        label: "Tocantins",
        value: "TO"
    }, 
];
var usePoolState = function(isGuest, poolInfo) {
    var ref;
    var ref1 = (0,ReCAPTCHAContext/* useReCAPTCHA */.V)(), handleVerifyRecaptcha = ref1.handleVerifyRecaptcha, recaptcha = ref1.recaptcha, refreshRecaptcha = ref1.refreshRecaptcha, setRefreshRecaptcha = ref1.setRefreshRecaptcha;
    var ref2 = (0,react.useState)(false), modalImageCropper = ref2[0], setModalImageCropper = ref2[1];
    var ref3 = (0,react.useState)("cover"), cropperSize = ref3[0], setCropperSize = ref3[1];
    var ref4 = (0,react.useState)("#fff6e8"), newBackGroundColor = ref4[0], setNewBackGroundColor = ref4[1];
    var ref5 = (0,react.useState)([]), messages = ref5[0], setMessages = ref5[1];
    var targetColor = {
        r: 255,
        g: 255,
        b: 255
    };
    var ref6 = (0,react.useState)([]), imgsPool = ref6[0], setImgsPool = ref6[1];
    var ref7 = (0,react.useState)(false), submit = ref7[0], setSubmit = ref7[1];
    var ref8 = (0,react.useState)(0), deviceWidth = ref8[0], setDeviceWidth = ref8[1];
    var ref9 = (0,Loader/* useLoader */.U)(), setLoader = ref9.setLoader, setLabel = ref9.setLabel;
    var ref10 = (0,react.useState)(), coverImage = ref10[0], setCoverImage = ref10[1];
    var ref11 = (0,react.useState)(), footerImage = ref11[0], setFooterImage = ref11[1];
    var ref12 = (0,react.useState)({
        slug: randomUUID(),
        fixedFee: 1
    }), formData = ref12[0], setFormData = ref12[1];
    var ref13 = (0,react.useState)({}), pool = ref13[0], setPool = ref13[1];
    var route = (0,router.useRouter)();
    var ref14 = (0,react.useState)(false), modalSocialShare = ref14[0], setModalSocialShare = ref14[1];
    var ref15 = (0,react.useState)([]), albumStaticImages = ref15[0], setAlbumStaticImages = ref15[1];
    var ref16 = (0,react.useState)(JSON.stringify({
        slug: formData.slug,
        fixedFee: formData.fixedFee
    })), snapData = ref16[0], setSnapData = ref16[1];
    var ref17 = (0,react.useState)(), titleStyles = ref17[0], setTitleStyles = ref17[1];
    var ref18 = (0,react.useState)(true), isValidSlug = ref18[0], setIsValidSlug = ref18[1];
    var ref19 = (0,react.useState)({}), messageForm = ref19[0], setMessageForm = ref19[1];
    var ref20 = (0,react.useState)([]), categories = ref20[0], setCategories = ref20[1];
    var ref21 = (0,react.useState)(""), selectedCategoryId = ref21[0], setSelectedCategoryId = ref21[1];
    var loadCategories = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        apiClient/* api.get */.h.get("pool-categories")
                    ];
                case 1:
                    data = _state.sent().data;
                    setCategories(data);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Erro ao carregar categorias:", error);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), []);
    var onCategoryChanged = (0,react.useCallback)(function(e) {
        setSelectedCategoryId(e.currentTarget.value);
    }, []);
    (0,react.useEffect)(function() {
        var ref, ref1;
        (poolInfo === null || poolInfo === void 0 ? void 0 : (ref = poolInfo.category) === null || ref === void 0 ? void 0 : ref.id) && setSelectedCategoryId(poolInfo === null || poolInfo === void 0 ? void 0 : (ref1 = poolInfo.category) === null || ref1 === void 0 ? void 0 : ref1.id);
    }, [
        poolInfo
    ]);
    (0,react.useEffect)(function() {
        loadCategories();
    }, [
        loadCategories
    ]);
    var handlerCropImage = function(file) {
        switch(cropperSize){
            case "cover":
                setCoverImage(file);
                break;
            case "footer":
                setFooterImage(file);
                break;
            case "album":
                if (!(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id)) {
                    setAlbumStaticImages(function(prev) {
                        return (0,_to_consumable_array/* default */.Z)(prev).concat([
                            file
                        ]);
                    });
                    setImgsPool(function(prev) {
                        return (0,_to_consumable_array/* default */.Z)(prev).concat([
                            {
                                id: (prev.length + 1).toString(),
                                partyId: "",
                                url: URL.createObjectURL(file)
                            }, 
                        ]);
                    });
                } else handleFileChange(file);
                break;
        }
    };
    var handleFileChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(photo, poolId, index) {
            var newFile, file, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoader === null || setLoader === void 0 ? void 0 : setLoader(true);
                        setLabel === null || setLabel === void 0 ? void 0 : setLabel(index ? "Adicionando foto(".concat(index, ") no album") : "Adicionando foto no album");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!photo) throw new Error("Nenhum arquivo selecionado");
                        newFile = photo;
                        file = new FormData();
                        file.append("photo", newFile);
                        return [
                            4,
                            apiClient/* api.post */.h.post("pools/".concat((poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id) || poolId, "/photos"), file).then(function(param) {
                                var data = param.data;
                                setImgsPool(function(oldState) {
                                    return (0,_to_consumable_array/* default */.Z)(oldState).concat([
                                        data
                                    ]);
                                });
                                (0,react_toastify_esm/* toast */.Am)("Foto adicionada", {
                                    type: "success"
                                });
                            }).catch(function(error) {
                                (0,react_toastify_esm/* toast */.Am)((error === null || error === void 0 ? void 0 : error.userMessage) || "Atualiza\xe7\xe3o de dados falhou", {
                                    type: "error"
                                });
                            }).finally(function() {
                                setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        console.log(err);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(photo, poolId, index) {
            return _ref.apply(this, arguments);
        };
    }(), [
        poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id,
        setImgsPool
    ]);
    var handleCoverChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(poolId) {
            var photo, newFile, file, error, ref, ref1, mensagem;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        photo = coverImage;
                        if (!photo) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setLoader === null || setLoader === void 0 ? void 0 : setLoader(true);
                        setLabel === null || setLabel === void 0 ? void 0 : setLabel("Salvando a imagem de capa...");
                        if (!photo) throw new Error("Nenhum arquivo selecionado");
                        newFile = photo;
                        file = new FormData();
                        file.append("cover", newFile);
                        return [
                            4,
                            apiClient/* api.patch */.h.patch("pools/".concat(poolId, "/cover"), file)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        mensagem = (error === null || error === void 0 ? void 0 : error.userMessage) || (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || (error === null || error === void 0 ? void 0 : error.message) || "Erro ao salvar a imagem de capa.";
                        (0,react_toastify_esm/* toast */.Am)(mensagem, {
                            type: "error",
                            style: {
                                fontSize: 14
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(poolId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        coverImage
    ]);
    var handleFooterChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(poolId) {
            var photo, newFile, file, error, ref, ref1, mensagem;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        photo = footerImage;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setLoader === null || setLoader === void 0 ? void 0 : setLoader(true);
                        setLabel === null || setLabel === void 0 ? void 0 : setLabel("Salvando a imagem do rodape...");
                        if (!photo) throw new Error("Nenhum arquivo selecionado");
                        newFile = photo;
                        file = new FormData();
                        file.append("footer", newFile);
                        return [
                            4,
                            apiClient/* api.patch */.h.patch("pools/".concat(poolId, "/footer"), file)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        mensagem = (error === null || error === void 0 ? void 0 : error.userMessage) || (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || (error === null || error === void 0 ? void 0 : error.message) || "Erro ao salvar a imagem do rodap\xe9.";
                        (0,react_toastify_esm/* toast */.Am)(mensagem, {
                            type: "error",
                            style: {
                                fontSize: 14
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(poolId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        footerImage
    ]);
    var getCropperSize = function() {
        return ({
            cover: {
                height: 800,
                width: 1920
            },
            album: {
                width: 1080,
                height: 1080
            },
            "lateral-l": {
                width: 314,
                height: 500
            },
            "lateral-r": {
                width: 314,
                height: 500
            },
            footer: {
                height: 700,
                width: 1920
            }
        })[cropperSize];
    };
    var toggleModalImageCropper = function(type) {
        setCropperSize(type);
        setModalImageCropper(function(prev) {
            return !prev;
        });
    };
    var ref22 = (0,react.useState)([]), valueOptions = ref22[0], setValueOptions = ref22[1];
    var ref23 = (0,react.useState)([
        15,
        30,
        50,
        100,
        150
    ]), deafutlValueOptions = ref23[0], setDefaultValueOptions = ref23[1];
    (0,react.useEffect)(function() {
        // Function to handle device width change
        var handleResize = function() {
            setDeviceWidth(window.innerWidth);
        };
        setDeviceWidth(window.innerWidth);
        // Add event listener for window resize
        window.addEventListener("resize", handleResize);
        // Cleanup the event listener on component unmount
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    var fixedFee = formData.fixedFee, formDataWithoutFixedFee = (0,_object_without_properties/* default */.Z)(formData, [
        "fixedFee"
    ]);
    var handlerEditPool = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var fixedFee, font_color, font_family, video_url, dt, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id)) return [
                        2
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    setLoader === null || setLoader === void 0 ? void 0 : setLoader(true);
                    setLabel === null || setLabel === void 0 ? void 0 : setLabel("Editando a vaquinha");
                    fixedFee = formData.fixedFee, font_color = formData.fontColor, font_family = formData.fontFamily, video_url = formData.videoUrl, dt = (0,_object_without_properties/* default */.Z)(formData, [
                        "fixedFee",
                        "fontColor",
                        "fontFamily",
                        "videoUrl"
                    ]);
                    // Converter o valor do campo target para o formato esperado pela API
                    dt.target = parseFloat(formData.target) * 100;
                    if (newBackGroundColor) {
                        dt.backgroundColor = newBackGroundColor;
                    }
                    return [
                        4,
                        apiClient/* api.patch */.h.patch("pools/".concat(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dt), {
                            font_color: font_color !== null && font_color !== void 0 ? font_color : "",
                            font_family: font_family !== null && font_family !== void 0 ? font_family : "",
                            video_url: video_url
                        })).then(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var ref, _tmp, _tmp1, _videoUrl;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = coverImage && poolInfo.id;
                                        if (!_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            handleCoverChange(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id)
                                        ];
                                    case 1:
                                        _tmp = _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        _tmp;
                                        _tmp1 = footerImage && poolInfo.id;
                                        if (!_tmp1) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            handleFooterChange(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id)
                                        ];
                                    case 3:
                                        _tmp1 = _state.sent();
                                        _state.label = 4;
                                    case 4:
                                        _tmp1;
                                        setPool((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pool, dt), {
                                            target: parseFloat((ref = dt.target || "0") === null || ref === void 0 ? void 0 : ref.toString()) / 100,
                                            fontColor: formData.fontColor,
                                            fontFamily: formData.fontFamily,
                                            videoUrl: (_videoUrl = formData.videoUrl) !== null && _videoUrl !== void 0 ? _videoUrl : "",
                                            state: formData.state
                                        }));
                                        setSnapData(JSON.stringify((0,_object_spread/* default */.Z)({}, formData)));
                                        (0,react_toastify_esm/* toast */.Am)("Vaquinha editada com sucesso", {
                                            type: "success"
                                        });
                                        return [
                                            2
                                        ];
                                }
                            });
                        })).catch(function(error) {
                            var ref, ref1;
                            var mensagem = (error === null || error === void 0 ? void 0 : error.userMessage) || (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Edi\xe7\xe3o da vaquinha falhou.";
                            (0,react_toastify_esm/* toast */.Am)(mensagem, {
                                type: "error",
                                style: {
                                    fontSize: 14
                                }
                            });
                        }).finally(function() {
                            setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
                            setSubmit(false);
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.log(error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id,
        setLoader,
        setLabel,
        formData,
        newBackGroundColor,
        coverImage,
        handleCoverChange,
        footerImage,
        handleFooterChange,
        pool, 
    ]);
    var handlerPool = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _fontColor, _fontFamily, _videoUrl, ref, font_color, font_family, video_url, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        5,
                        6
                    ]);
                    if (!!(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id)) return [
                        3,
                        2
                    ];
                    setLoader === null || setLoader === void 0 ? void 0 : setLoader(true);
                    ref = [
                        (_fontColor = formData.fontColor) !== null && _fontColor !== void 0 ? _fontColor : "",
                        (_fontFamily = formData.fontFamily) !== null && _fontFamily !== void 0 ? _fontFamily : "",
                        (_videoUrl = formData.videoUrl) !== null && _videoUrl !== void 0 ? _videoUrl : ""
                    ], font_color = ref[0], font_family = ref[1], video_url = ref[2];
                    delete formData.fontColor;
                    delete formData.fontFamily;
                    delete formDataWithoutFixedFee.fontColor;
                    delete formDataWithoutFixedFee.fontFamily;
                    delete formDataWithoutFixedFee.videoUrl;
                    return [
                        4,
                        apiClient/* api.post */.h.post("pools", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formDataWithoutFixedFee), {
                            target: parseFloat(formData.target) * 100,
                            background_color: newBackGroundColor,
                            font_color: font_color,
                            font_family: font_family,
                            category_id: selectedCategoryId,
                            video_url: video_url
                        })).then(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                                var data, _tmp, _tmp1;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            data = param.data;
                                            _tmp = coverImage;
                                            if (!_tmp) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                handleCoverChange(data === null || data === void 0 ? void 0 : data.id)
                                            ];
                                        case 1:
                                            _tmp = _state.sent();
                                            _state.label = 2;
                                        case 2:
                                            _tmp;
                                            _tmp1 = footerImage;
                                            if (!_tmp1) return [
                                                3,
                                                4
                                            ];
                                            return [
                                                4,
                                                handleFooterChange(data === null || data === void 0 ? void 0 : data.id)
                                            ];
                                        case 3:
                                            _tmp1 = _state.sent();
                                            _state.label = 4;
                                        case 4:
                                            _tmp1;
                                            if (albumStaticImages && (data === null || data === void 0 ? void 0 : data.id)) {
                                                albumStaticImages.map(function(file, index) {
                                                    return handleFileChange(file, data.id, index + 1);
                                                });
                                            }
                                            (0,react_toastify_esm/* toast */.Am)("Vaquinha criada com sucesso", {
                                                type: "success"
                                            });
                                            setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
                                            route.replace("/pool/" + data.slug);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(_) {
                                return _ref.apply(this, arguments);
                            };
                        }()).catch(function(error) {
                            var ref, ref1;
                            var mensagem = (error === null || error === void 0 ? void 0 : error.userMessage) || (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Cria\xe7\xe3o da vaquinha falhou.";
                            (0,react_toastify_esm/* toast */.Am)(mensagem, {
                                type: "error",
                                style: {
                                    fontSize: 14
                                }
                            });
                            setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    handlerEditPool();
                    _state.label = 3;
                case 3:
                    return [
                        3,
                        6
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    return [
                        3,
                        6
                    ];
                case 5:
                    setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
                    return [
                        7
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    }), [
        poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id,
        handlerEditPool,
        setLoader,
        formData.fontColor,
        formData.fontFamily,
        formData.target,
        formData.videoUrl,
        formDataWithoutFixedFee,
        newBackGroundColor,
        selectedCategoryId,
        coverImage,
        handleCoverChange,
        footerImage,
        handleFooterChange,
        albumStaticImages,
        route,
        handleFileChange, 
    ]);
    (0,react.useEffect)(function() {
        var timeout = setTimeout(function() {
            var ref;
            var ref1;
            if (formData.title && formData.target && formData.description && !pool.id || (poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id) && (snapData !== JSON.stringify(formData) || coverImage || footerImage) || (poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id) && newBackGroundColor && newBackGroundColor !== pool.backgroundColor || (poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id) && ((ref1 = poolInfo === null || poolInfo === void 0 ? void 0 : (ref = poolInfo.category) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "") !== selectedCategoryId) {
                setSubmit(true);
            } else setSubmit(false);
        }, 300);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id,
        formData,
        valueOptions,
        newBackGroundColor,
        snapData,
        footerImage,
        pool.id,
        pool.backgroundColor,
        coverImage,
        poolInfo === null || poolInfo === void 0 ? void 0 : (ref = poolInfo.category) === null || ref === void 0 ? void 0 : ref.id,
        selectedCategoryId, 
    ]);
    var distance = getColorDistance(targetColor, hexToRgb(newBackGroundColor || ""));
    var fontColor = (0,react.useMemo)(function() {
        return distance < similarityThreshold ? "#174F68" : "#ffffff";
    }, [
        distance
    ]);
    var handlerSendMessage = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(poolId) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setLoader === null || setLoader === void 0 ? void 0 : setLoader(true);
                        return [
                            4,
                            apiClient/* api.post */.h.post("pools/".concat(poolId, "/messages"), (0,_object_spread/* default */.Z)({}, messageForm)).then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                                    var data;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        data = param.data;
                                        (0,react_toastify_esm/* toast */.Am)("Mensagem enviada com sucesso", {
                                            type: "success"
                                        });
                                        setMessageForm({
                                            content: "",
                                            name: ""
                                        });
                                        setMessages((0,_to_consumable_array/* default */.Z)(messages).concat([
                                            data
                                        ]));
                                        setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(error) {
                                var ref, ref1;
                                var mensagem = (error === null || error === void 0 ? void 0 : error.userMessage) || (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Envio da mensagem falhou.";
                                (0,react_toastify_esm/* toast */.Am)(mensagem, {
                                    type: "error",
                                    style: {
                                        fontSize: 14
                                    }
                                });
                                setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(poolId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        messageForm,
        messages
    ]);
    var handleModerateMessage = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(messageId, visible) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            apiClient/* api.patch */.h.patch("pools/".concat(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id, "/messages/").concat(messageId, "/toggle_visible"))
                        ];
                    case 1:
                        _state.sent();
                        if (visible) {
                            setMessages(function(previous) {
                                return previous.map(function(item) {
                                    return item.id === messageId ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                        visible: false
                                    }) : item;
                                });
                            });
                        }
                        if (!visible) {
                            setMessages(function(previous) {
                                return previous.map(function(item) {
                                    return item.id === messageId ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                        visible: true
                                    }) : item;
                                });
                            });
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(messageId, visible) {
            return _ref.apply(this, arguments);
        };
    }(), [
        poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id
    ]);
    (0,react.useEffect)(function() {
        if (!(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id)) return;
        if (isGuest) {
            apiClient/* api.get */.h.get("pools/".concat(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id, "/messages")).then(function(param) {
                var data = param.data;
                setMessages(data.values);
            });
        } else {
            apiClient/* api.get */.h.get("pools/".concat(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id, "/messages/all")).then(function(param) {
                var data = param.data;
                setMessages(data.values);
            });
        }
        apiClient/* api.get */.h.get("pools/".concat(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id, "/photos")).then(function(param) {
            var data = param.data;
            setImgsPool(data.values);
        });
    }, [
        isGuest,
        poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id
    ]);
    var handleRemoveImg = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        if (!(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id)) return [
                            3,
                            2
                        ];
                        setLoader === null || setLoader === void 0 ? void 0 : setLoader(true);
                        setLabel === null || setLabel === void 0 ? void 0 : setLabel("Removendo a foto do album");
                        return [
                            4,
                            apiClient/* api.delete */.h["delete"]("pools/".concat(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id, "/photos/").concat(id)).then(function(param) {
                                var data = param.data;
                                setImgsPool(function(oldState) {
                                    return oldState.filter(function(i) {
                                        return i.id !== id;
                                    });
                                });
                                (0,react_toastify_esm/* toast */.Am)("Foto removida com sucesso", {
                                    type: "success"
                                });
                            }).catch(function(error) {
                                (0,react_toastify_esm/* toast */.Am)((error === null || error === void 0 ? void 0 : error.userMessage) || "Atualiza\xe7\xe3o de dados falhou", {
                                    type: "error"
                                });
                            }).finally(function() {
                                setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setAlbumStaticImages(function(prev) {
                            return prev.filter(function(_, index) {
                                return (index + 1).toString() !== id;
                            });
                        });
                        setImgsPool(function(prev) {
                            return prev.filter(function(item) {
                                return item.id !== id;
                            });
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(), [
        poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id,
        setImgsPool,
        imgsPool,
        albumStaticImages
    ]);
    var handlerShareData = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (!poolInfo) return [
                2
            ];
            try {
                /*await navigator.share({
        title: 'Vaquinha Meu Nascimento | ' + poolInfo?.title,
        text: poolInfo?.description,
        url: window.location.origin + '/' + poolInfo?.slug,
      });*/ setModalSocialShare(true);
            } catch (err) {
                (0,react_toastify_esm/* toast */.Am)("[".concat(err, "] vaquinha n\xe3o compartilhada"), {
                    type: "error"
                });
            }
            return [
                2
            ];
        });
    }), [
        poolInfo
    ]);
    var handlerTitleStyles = function(value) {
        return setTitleStyles(value);
    };
    var formatEventStyle = (0,react.useMemo)(function() {
        if (!pool.fontFamily) return;
        else return JSON.parse(pool.fontFamily || "");
    }, [
        pool
    ]);
    (0,react.useEffect)(function() {
        if (!formatEventStyle && (titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.fontFamily) === "P22 Mackinac Pro" && titleStyles.color === "#8B8EE8" && titleStyles.fontWeight === "normal" && titleStyles.textDecoration === "none" && titleStyles.fontStyle === "normal") return;
        var stringStyle = JSON.stringify({
            fontFamily: titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.fontFamily,
            textDecoration: titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.textDecoration,
            fontStyle: titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.fontStyle,
            fontWeight: titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.fontWeight
        });
        if (stringStyle === "{}") return;
        if (stringStyle !== pool.fontFamily || pool.fontColor !== (titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.color)) setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
            fontColor: titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.color,
            fontFamily: stringStyle
        }));
    }, [
        formatEventStyle,
        titleStyles,
        pool
    ]);
    (0,react.useEffect)(function() {
        if (!pool) {
            handlerTitleStyles({
                fontFamily: "P22 Mackinac Pro",
                color: "#8B8EE8"
            });
        } else handlerTitleStyles((0,_object_spread/* default */.Z)({
            color: pool.fontColor
        }, formatEventStyle));
    }, [
        formatEventStyle
    ]);
    var handleVerifySlug = (0,react.useCallback)(function(value) {
        setLoader === null || setLoader === void 0 ? void 0 : setLoader(true);
        setLabel === null || setLabel === void 0 ? void 0 : setLabel("verificando a slug!...");
        apiClient/* api.get */.h.get("pools/verify_slug/".concat(value)).then(function(param) {
            var res = param.data;
            setIsValidSlug(res === null || res === void 0 ? void 0 : res.available);
        }).catch(function() {
            return setIsValidSlug(false);
        }).finally(function() {
            return setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
        });
    }, [
        setLabel,
        setLoader
    ]);
    (0,react.useEffect)(function() {
        if (poolInfo) {
            if (poolInfo.status) {
                setPool(function(prev) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev, poolInfo), {
                        active: poolInfo.status !== "finished"
                    });
                });
            }
        }
    }, [
        poolInfo,
        setPool
    ]);
    var reloadPoolData = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var response, mappedData, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.slug)) return [
                        2
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        apiClient/* api.get */.h.get("pools/".concat(poolInfo.slug))
                    ];
                case 2:
                    response = _state.sent();
                    mappedData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, response.data), {
                        active: response.data.status !== "finished"
                    });
                    setPool(mappedData);
                    return [
                        2,
                        mappedData
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.slug,
        setPool
    ]);
    var handleFinishCampaign = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var response, reloadedData, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id)) return [
                        2
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        5,
                        6
                    ]);
                    setLoader === null || setLoader === void 0 ? void 0 : setLoader(true);
                    setLabel === null || setLabel === void 0 ? void 0 : setLabel("Finalizando a campanha...");
                    return [
                        4,
                        apiClient/* api.patch */.h.patch("pools/".concat(poolInfo.id, "/finish"))
                    ];
                case 2:
                    response = _state.sent();
                    setPool(function(prev) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                            active: false,
                            status: "finished"
                        });
                    });
                    return [
                        4,
                        reloadPoolData()
                    ];
                case 3:
                    reloadedData = _state.sent();
                    (0,react_toastify_esm/* toast */.Am)("Campanha finalizada com sucesso", {
                        type: "success"
                    });
                    return [
                        2,
                        true
                    ];
                case 4:
                    error = _state.sent();
                    (0,react_toastify_esm/* toast */.Am)("Erro ao finalizar a campanha", {
                        type: "error"
                    });
                    return [
                        2,
                        false
                    ];
                case 5:
                    setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
                    return [
                        7
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    }), [
        poolInfo === null || poolInfo === void 0 ? void 0 : poolInfo.id,
        setLoader,
        setLabel,
        setPool,
        reloadPoolData
    ]);
    return {
        onCategoryChanged: onCategoryChanged,
        categories: categories,
        modalSocialShare: modalSocialShare,
        setModalSocialShare: setModalSocialShare,
        pool: pool,
        setPool: setPool,
        handlerShareData: handlerShareData,
        handleRemoveImg: handleRemoveImg,
        imgsPool: imgsPool,
        setImgsPool: setImgsPool,
        handlerSendMessage: handlerSendMessage,
        messageForm: messageForm,
        setMessageForm: setMessageForm,
        cropperSize: cropperSize,
        footerImage: footerImage,
        fontColor: fontColor,
        newBackGroundColor: newBackGroundColor,
        setNewBackGroundColor: setNewBackGroundColor,
        valueOptions: valueOptions,
        setValueOptions: setValueOptions,
        deafutlValueOptions: deafutlValueOptions,
        setDefaultValueOptions: setDefaultValueOptions,
        submit: submit,
        handlerPool: handlerPool,
        deviceWidth: deviceWidth,
        messages: messages,
        modalImageCropper: modalImageCropper,
        setModalImageCropper: setModalImageCropper,
        handleVerifyRecaptcha: handleVerifyRecaptcha,
        recaptcha: recaptcha,
        refreshRecaptcha: refreshRecaptcha,
        setRefreshRecaptcha: setRefreshRecaptcha,
        handlerCropImage: handlerCropImage,
        getCropperSize: getCropperSize,
        toggleModalImageCropper: toggleModalImageCropper,
        handleModerateMessage: handleModerateMessage,
        handleVerifySlug: handleVerifySlug,
        isValidSlug: isValidSlug,
        setSelectedCategoryId: setSelectedCategoryId,
        selectedCategoryId: selectedCategoryId,
        handlerEditPool: handlerEditPool,
        handleFinishCampaign: handleFinishCampaign,
        /**Form */ formData: formData,
        setFormData: setFormData,
        snapData: snapData,
        setSnapData: setSnapData,
        /** title styles */ handlerTitleStyles: handlerTitleStyles,
        titleStyles: titleStyles,
        formatEventStyle: formatEventStyle,
        reloadPoolData: reloadPoolData
    };
};

// EXTERNAL MODULE: ./utils/verification.ts
var verification = __webpack_require__(40520);
// EXTERNAL MODULE: ./node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js + 2 modules
var react_textarea_autosize_browser_esm = __webpack_require__(16093);
;// CONCATENATED MODULE: ./templates/pool/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: 100vw;\n  background: ",
        ";\n  overflow: hidden;\n\n  &select,\n  option {\n    color: black !important;\n  }\n\n  & .swiper-wrapper {\n    display: flex;\n    align-items: center;\n  }\n  \n  & .swiper-pagination {\n    position: relative;\n    margin-top: 20px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    bottom: 0 !important;\n    \n    & .swiper-pagination-bullet {\n      margin: 0 5px;\n    }\n  }\n\n  .activeSlider {\n    opacity: 1;\n    width: 25px;\n    border-radius: 100px;\n    background-color: #174f68 !important;\n  }\n\n  .player-button {\n    position: absolute;\n    right: 1rem;\n    top: 35%;\n    height: auto;\n    width: 40px;\n    background-color: rgba(0, 0, 0, 0.4);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 8px;\n    transition: all .2s;\n    cursor: pointer;\n\n    &:hover{\n      background-color: #174f68 !important;\n    }\n\n    & svg {\n      height: 30px;\n      width: 30px;\n      fill: #fff;\n      padding: 5px 0;\n    }\n  }\n\n  & > div:first-child {\n    z-index: 999;\n    background: ",
        ";\n  }\n\n  & .button-color {\n    padding-left: 60px;\n\n    & .picker-svg {\n      position: absolute;\n      left: 15px;\n      top: 15px !important;\n    }\n    & input[type='color'] {\n      position: absolute;\n      width: 50px;\n      height: 100%;\n      left: -1px;\n      border: none;\n      background: none;\n      cursor: pointer;\n      margin: 0 !important;\n      padding: 0 !important;\n\n      &::-webkit-color-swatch-wrapper {\n        position: absolute;\n        top: 0;\n        left: 0;\n        padding: 0;\n        top: -1.2rem;\n      }\n\n      &::-webkit-color-swatch {\n        border: solid 2px transparent;\n        border-top-left-radius: 8px;\n        border-bottom-left-radius: 8px;\n        border: 1px solid #174f68;\n      }\n    }\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 130em;\n  width: 100%;\n\n  height: 7rem;\n  margin: 0 auto;\n  padding: 0 2rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  z-index: 10;\n\n  & > div {\n    padding: 1.5rem 0;\n    display: flex;\n\n    &:first-child {\n      flex: 1;\n    }\n\n    &:last-child button {\n      display: none;\n    }\n\n    &:last-child nav ul {\n      display: grid;\n      grid-template-columns: auto auto auto;\n      grid-column-gap: 45px;\n      list-style: none;\n\n      & a,\n      & a:link,\n      & a:visited {\n        font-family: 'Nunito';\n        font-size: 16px;\n        font-weight: 500;\n        text-align: center;\n        color: ",
        " !important;\n        text-decoration: none;\n      }\n    }\n  }\n\n  ",
        " {\n    padding: 0 34px;\n\n    & > div:last-child nav {\n      display: none;\n    }\n    & > div:last-child button {\n      background-color: transparent;\n      outline: none;\n      border: none;\n      display: flex;\n      cursor: pointer;\n    }\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 34px;\n  background: #fff6e8;\n\n  & li a {\n    & > span:first-child {\n      display: block;\n      margin-right: 1rem;\n    }\n    & > span:nth-child(3) {\n      display: none;\n    }\n  }\n\n  & > div nav ul {\n    display: grid;\n    grid-template-columns: auto auto auto;\n    grid-column-gap: 45px;\n    list-style: none;\n    max-width: 100vw;\n\n    @media (max-width: 374px) {\n      grid-column-gap: 35px;\n    }\n\n    & a,\n    & a:link,\n    & a:visited {\n      font-family: 'Nunito';\n      font-size: 14px;\n      font-weight: 500;\n      text-align: center;\n      color: ",
        ";\n      text-decoration: none;\n      display: flex;\n      align-items: center;\n\n      & > span:last-child {\n        display: none;\n      }\n      & > span:first-child {\n        display: block;\n      }\n    }\n  }\n  ",
        " {\n    & ul {\n      padding: 0 !important;\n    }\n    & li a {\n      & > span:nth-child(2) {\n        display: none;\n      }\n      & > span:first-child {\n        display: block;\n      }\n      & > span:nth-child(3) {\n        display: block;\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 30px 102px;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  background-color: ",
        ";\n  color: ",
        " !important;\n  & > div {\n    display: flex;\n\n    &:nth-child(2) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      & > p {\n        font-family: 'Nunito';\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 24px;\n        letter-spacing: 0em;\n        text-align: center;\n      }\n    }\n    &:last-child {\n      display: flex;\n      flex-direction: row;\n      list-style: none;\n\n      & ul {\n        display: flex;\n        flex-direction: row;\n        list-style: none;\n\n        & > li {\n          margin-left: 1.5rem;\n        }\n      }\n    }\n  }\n  ",
        " {\n    padding: 77px 34px;\n    grid-template-columns: 1fr;\n\n    & > div {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n\n      &:first-child {\n        grid-row-start: 2;\n        grid-row-end: 3;\n      }\n      &:nth-child(2) {\n        grid-row-start: 0;\n        grid-row-end: 1;\n      }\n      &:last-child {\n        grid-row-start: 1;\n        grid-row-end: 2;\n\n        & ul {\n          padding: 0;\n        }\n      }\n    }\n  }\n\n  & > span {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  left: ",
        "%;\n  background-color: rgba(0, 0, 0, 0.4);\n  transition: all 0.2s ease-in-out;\n\n  & nav {\n    min-width: 250px;\n    width: fit-content;\n    padding: 34px;\n    background-color: #fff6e8;\n    height: 100%;\n\n    & > ul {\n      list-style: none;\n      display: flex;\n      flex-direction: column;\n      margin: 0;\n      padding: 0;\n\n      & > li {\n        & a,\n        & a:link,\n        & a:visited {\n          font-family: 'Nunito';\n          font-size: 16px;\n          font-weight: 500;\n          line-height: 34px;\n          text-decoration: none;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-evenly !important;\n  display: flex;\n\n  p {\n    cursor: pointer;\n  }\n\n  @media (max-width: 820px) {\n    display: grid !important;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid !important;\n  justify-items: center !important;\n\n  .mobile-copyright {\n    display: none;\n  }\n\n  p {\n    font-size: 12px;\n  }\n\n  @media (max-width: 820px) {\n    .mobile-copyright {\n      display: block;\n    }\n    .web-copyright {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1.2rem;\n  @media (max-width: 820px) {\n    display: none !important;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  @media (max-width: 820px) {\n    display: block;\n    list-style: none;\n    margin-bottom: 2rem;\n    margin-left: -1rem;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Nunito';\n  color: ",
        " !important;\n  background-color: ",
        " !important;\n\n  & .bulletActive {\n    background: ",
        ";\n    opacity: 1;\n  }\n\n  .modal-preview {\n    background-color: red;\n  }\n\n  & button {\n    color: #ffffff;\n    padding: 12px 25px;\n    background-color: #174f68;\n    font-family: 'Nunito';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    outline: none;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    //max-width: fit-content;\n\n    &[disabled] {\n      background-color: rgba(217, 217, 217, 1);\n      cursor: default !important;\n    }\n  }\n\n  & h2 {\n    font-family: 'P22 Mackinac Pro';\n    font-size: 28px;\n    font-weight: 500;\n    margin: 52px 0;\n  }\n\n  & h4 {\n    font-family: 'Nunito';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 20px;\n    text-align: center;\n    margin-bottom: 30px;\n  }\n\n  & > section {\n    display: flex;\n    position: relative;\n    justify-content: center;\n    align-items: center;\n\n    &:first-child {\n      overflow: hidden;\n      align-items: flex-end;\n\n      & > img:first-child {\n        position: absolute;\n        top: 0;\n        left: 0;\n      }\n      & > img:last-child {\n        position: absolute;\n        right: 0;\n      }\n    }\n    &:nth-child(2) {\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      min-height: 300px;\n\n      & > div {\n        max-width: 525px;\n        &:first-child {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          /*max-width: none !important;*/\n          width: 100%;\n          padding-top: 3rem;\n          margin-top: -7rem;\n\n          & > h1:nth-child(3) {\n            text-align: center;\n          }\n\n          & div {\n            padding: 0 4rem;\n            padding-bottom: 7rem;\n            max-width: 525px;\n            & h1 {\n              font-family: 'P22 Mackinac Pro';\n              font-size: 64px;\n              text-align: center;\n              font-weight: 500;\n            }\n          }\n        }\n        &:nth-child(2) {\n          display: grid;\n          grid-template-columns: 1fr 1fr;\n          grid-column-gap: 30px;\n          padding: 1rem 0;\n          width: 100%;\n\n          & > div {\n            font-size: 14px;\n            &:first-child,\n            &:nth-child(2) {\n              font-family: 'Nunito';\n              font-size: 18px;\n              font-weight: 500;\n              line-height: 42px;\n              letter-spacing: 0em;\n              text-align: left;\n            }\n          }\n        }\n      }\n    }\n    &:nth-child(3) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 7rem 0;\n\n      & > p {\n        text-align: center;\n        font-size: 26px;\n        max-width: 755px;\n      }\n    }\n    &:last-child {\n      display: flex;\n      justify-content: center;\n      background-position: bottom !important;\n      background-size: 100% auto !important;\n      min-height: 850px;\n      background-repeat: no-repeat;\n      align-items: flex-start;\n\n      & > img {\n        position: absolute;\n\n        &:first-child {\n          top: -5rem;\n          left: 0;\n        }\n        &:last-child {\n          right: 0;\n        }\n      }\n\n      & > div {\n        min-width: 400px;\n        height: fit-content;\n      }\n    }\n  }\n\n  ",
        " {\n    & > section:first-child {\n      background-size: contain;\n\n      & > img:first-child {\n        top: -4rem;\n        left: 0;\n      }\n      & > img:last-child {\n        right: 0;\n      }\n    }\n    & > section:nth-child(2) {\n      padding: 0 34px;\n    }\n    & > section:nth-child(3) {\n      padding: 7rem 34px;\n\n      & p {\n        font-size: 20px;\n      }\n    }\n    & > section:last-child {\n      position: relative;\n      & > img {\n        &:first-child {\n          top: 0;\n          left: 0;\n        }\n        &:last-child {\n          right: 0;\n        }\n      }\n\n      & > div {\n        min-width: 300px;\n        height: fit-content;\n\n        position: absolute !important;\n        bottom: 25% !important;\n      }\n    }\n  }\n  ",
        " {\n    & > section:first-child {\n      min-height: 200px;\n      & > img:first-child {\n        top: -15rem;\n        left: 0;\n      }\n      & > img:last-child {\n        top: -15rem;\n        right: 0;\n      }\n    }\n    & > section:nth-child(2) {\n      & > div {\n        &:first-child {\n          padding: 4rem;\n          & > h1 {\n            font-size: 34px;\n          }\n        }\n        &:nth-child(2) {\n          display: grid;\n          grid-template-columns: 1fr 1fr;\n          grid-column-gap: 30px;\n          padding: 1rem 0;\n          width: 100%;\n\n          & > div {\n            font-size: 12px;\n            &:first-child,\n            &:nth-child(2) {\n              font-family: 'Nunito';\n              font-size: 14px;\n              font-weight: 500;\n              line-height: 42px;\n              letter-spacing: 0em;\n              text-align: left;\n            }\n          }\n        }\n      }\n    }\n    & > section:last-child {\n      align-items: center;\n      min-height: 500px;\n      & > img {\n        &:first-child {\n          top: 50px;\n          left: 0;\n        }\n        &:last-child {\n          /* bottom: -30px; */\n          right: 0;\n        }\n      }\n      & > div {\n        min-width: 250px;\n        height: fit-content;\n\n        position: absolute !important;\n        bottom: 5% !important;\n      }\n    }\n  }\n  /* Extra small devices (phones, 600px and down) */\n  @media only screen and (max-width: 375px) {\n    & > section:first-child {\n      background-size: 100% auto !important;\n      height: ",
        " !important;\n      min-height: auto;\n    }\n  }\n  /* Extra small devices (phones, 600px and down) */\n  @media (min-width: 375px) and (max-width: 600px) {\n    & > section:first-child {\n      background-size: ",
        ";\n      height: ",
        " !important;\n    }\n    & > section:last-child {\n      background-size: ",
        ";\n      height: ",
        " !important;\n    }\n  }\n\n  /* Small devices (portrait tablets and large phones, 600px and up) */\n  @media only screen and (min-width: 600px) {\n    & > section:first-child {\n      background-size: ",
        ";\n      height: ",
        " !important;\n    }\n  }\n\n  /* Medium devices (landscape tablets, 768px and up) */\n  @media only screen and (min-width: 768px) {\n    & > section:first-child {\n      height: 380px !important;\n    }\n  }\n\n  /* Large devices (laptops/desktops, 992px and up) */\n  @media only screen and (min-width: 992px) {\n    & > section:first-child {\n      height: 460px !important;\n    }\n  }\n\n  @media only screen and (min-width: 1100px) {\n    & > section:first-child {\n      height: 550px !important;\n    }\n  }\n\n  /* Extra large devices (large laptops and desktops, 1200px and up) */\n  @media only screen and (min-width: 1200px) {\n    & > section:first-child {\n      height: 610px !important;\n      background-size: cover;\n    }\n  }\n\n  @media only screen and (min-width: 1400px) {\n    & > section:first-child {\n      height: 700px !important;\n    }\n  }\n\n  @media only screen and (min-width: 1500px) {\n    & > section:first-child {\n      height: 750px !important;\n    }\n  }\n\n  @media only screen and (min-width: 1700px) {\n    & > section:first-child {\n      height: 800px !important;\n    }\n  }\n\n  @media only screen and (min-width: 1800px) {\n    & > section:first-child {\n      height: 815px !important;\n      background-size: cover;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  height: 815px !important;\n  background-size: center !important;\n  background-repeat: no-repeat !important;\n  background-position: center top !important;\n  @media (max-width: 600px) {\n    ",
        ";\n\n    background-repeat: no-repeat !important;\n    background-position: top !important;\n    background-size: ",
        " !important;\n    height: ",
        " !important;\n  }\n  @media only screen and (min-width: 600px) and (max-width: 992px) {\n    height: 400px !important;\n  }\n  @media (max-width: 350px) {\n    height: 160px !important;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  height: 815px !important;\n  min-height: auto !important;\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  background-position: bottom !important;\n\n  @media (max-width: 600px) {\n    height: 260px !important;\n\n    ",
        ";\n    background-repeat: no-repeat !important;\n    background-position: center !important;\n    background-size: 100% auto !important;\n    margin-top: -80px !important;\n  }\n\n  @media only screen and (min-width: 600px) and (max-width: 992px) {\n    height: 400px !important;\n  }\n  @media only screen and (max-width: 350px) {\n    height: 160px !important;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 7rem;\n  padding: 0 !important;\n  width: 100%;\n  overflow: hidden;\n\n  & h2 {\n    margin-bottom: 2rem;\n  }\n\n  & .bulletActive {\n    background: white;\n    opacity: 1;\n  }\n\n  & .swiper {\n    width: 100%;\n    max-width: 1200px;\n    padding: 0;\n    overflow: visible;\n  }\n\n  & .swiper-wrapper {\n    align-items: center;\n  }\n\n  & .swiper-slide {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 400px !important; /* Fixed width to match the component */\n  }\n\n  & .message {\n    font-family: 'Nunito';\n    width: 100%;\n    max-width: 400px;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    padding: 30px;\n    font-size: 16px;\n    margin: 0 auto;\n    background-color: rgba(255, 255, 255, 0.1);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n\n    p {\n      font-family: inherit;\n      font-weight: 700;\n      line-height: 27px;\n      font-size: inherit;\n      letter-spacing: 0em;\n      text-align: left;\n      margin-bottom: 15px;\n      overflow-wrap: break-word;\n      word-break: break-word;\n    }\n\n    span {\n      font-family: inherit;\n      font-size: inherit;\n      font-weight: 400;\n      line-height: 30px;\n      letter-spacing: 0em;\n      text-align: left;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex-wrap: wrap;\n\n      & > span {\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n  \n  & > *:last-child {\n    max-width: 100%;\n    padding: 0 34px;\n  }\n\n  @media (max-width: 768px) {\n    & .swiper {\n      padding: 0 10px;\n    }\n    \n    & .message {\n      padding: 20px;\n      max-width: 300px;\n    }\n    \n    & .swiper-slide {\n      width: 300px !important;\n    }\n  }\n\n  @media (max-width: 480px) {\n    & .message {\n      max-width: 280px;\n      padding: 15px;\n    }\n    \n    & .swiper-slide {\n      width: 280px !important;\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: fit-content;\n  margin-right: 8px;\n\n  & input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n    margin: 0;\n    padding: 0;\n  }\n\n  & label {\n    position: relative;\n    cursor: pointer;\n    width: 40px;\n    height: 20px;\n    background-color: #ccc;\n    transition: 0.4s;\n    border-radius: 34px;\n    margin: 0;\n    padding: 0;\n    display: inline-block;\n  }\n\n  & label:before {\n    position: absolute;\n    content: '';\n    height: 16px;\n    width: 16px;\n    left: 2px;\n    bottom: 2px;\n    background-color: white;\n    transition: 0.4s;\n    border-radius: 50%;\n  }\n\n  & input:checked + label {\n    background-color: #5cc9aa;\n  }\n\n  & input:checked + label:before {\n    transform: translateX(20px);\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n  padding: 0 4rem;\n\n  & h1 {\n    font-size: 62.6726px !important;\n    max-width: 872px;\n    text-align: center;\n    overflow-wrap: anywhere !important;\n  }\n\n  ",
        " {\n    padding: 0 2rem !important;\n    min-height: auto !important;\n    & h1 {\n      font-size: 40px !important;\n      max-width: 600px;\n    }\n  }\n\n  ",
        " {\n    & h1 {\n      font-size: 35px !important;\n      max-width: 250px;\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0 4rem;\n\n  & > div {\n    display: flex;\n    flex-direction: row;\n    flex: 1;\n    align-self: center;\n    max-width: 130em;\n    margin: 0 auto;\n    gap: 2rem;\n\n    & > div {\n      flex: 1;\n\n      &:first-child {\n        display: flex;\n        flex-direction: column;\n\n        & p {\n          font-family: 'Nunito';\n          font-size: 30px;\n          font-weight: 500;\n          line-height: 50px;\n          text-align: left;\n          max-width: 90%;\n        }\n\n        & > div {\n          max-width: 90%;\n\n          & strong {\n            font-family: 'Nunito';\n            font-size: 22px;\n            font-weight: 500;\n            text-align: left;\n          }\n\n          & input,\n          textarea {\n            position: relative;\n            border: 1px solid ",
        ";\n            background-color: transparent;\n            width: 100%;\n            border-radius: 8px;\n            padding: 1.2rem 0.9rem;\n            outline: none;\n            font-size: 16px;\n            margin-top: 1rem;\n            color: ",
        ";\n            appearance: none;\n            -webkit-appearance: none;\n            -moz-appearance: none;\n\n            ::placeholder {\n              color: ",
        ";\n              opacity: 0.5;\n            }\n            :disabled {\n              background-color: rgba(0, 0, 0, 0.4);\n            }\n          }\n\n          & select {\n            position: relative;\n            border: 1px solid ",
        ";\n            background-color: transparent;\n            width: 100%;\n            border-radius: 8px;\n            padding: 1.2rem 0.9rem;\n            outline: none;\n            font-size: 16px;\n            margin-top: 1rem;\n            color: ",
        ";\n            appearance: none;\n            -webkit-appearance: none;\n            -moz-appearance: none;\n\n            ::placeholder {\n              color: ",
        ";\n              opacity: 0.5;\n            }\n            :disabled {\n              background-color: rgba(0, 0, 0, 0.4);\n            }\n          }\n\n          & textarea {\n            resize: none;\n            height: 127px;\n          }\n\n          &:last-child {\n            display: flex;\n            flex-direction: row;\n            flex-wrap: wrap;\n            justify-content: center;\n            align-items: center;\n            gap: 10px;\n            & button {\n              width: 100%;\n              text-align: center;\n            }\n\n            & > span {\n              flex: 1;\n              :last-child {\n              }\n            }\n          }\n        }\n      }\n\n      &:last-child {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n  }\n\n  ",
        " {\n    & > div {\n      flex-direction: column-reverse;\n      & > div {\n        &:first-child {\n          & p {\n            font-size: 18px;\n            line-height: 30px;\n            max-width: 100%;\n            padding: 0 1.5rem;\n          }\n          & > div {\n            max-width: 100%;\n          }\n        }\n      }\n    }\n  }\n\n  ",
        " {\n    & > div {\n      display: flex;\n      flex-direction: column-reverse;\n\n      & p {\n        line-height: 26px !important;\n        font-size: 16px !important;\n      }\n    }\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 0 15em;\n  max-width: 130em;\n  margin: 32px auto;\n  justify-content: center;\n\n  ",
        " {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    align-self: center;\n  }\n\n  ",
        " {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    padding: 0 !important;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  padding: 9px 20px;\n  font-weight: 600;\n  border: ",
        "!important;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  padding: 0 15em;\n  margin: 0 auto !important;\n  display: block;\n  width: 100%;\n  text-align: center;\n\n  @media (max-width: 500px) {\n    padding: 0;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0 4rem;\n\n  & > div:last-child {\n    width: 100%;\n    & > div {\n      flex: 1;\n\n      margin-bottom: 2rem;\n\n      &:last-child {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n\n        & p {\n          font-family: 'Nunito';\n          font-size: 30px;\n          font-weight: 500;\n          line-height: 50px;\n          text-align: left;\n          max-width: 90%;\n        }\n\n        & > div {\n          :not(:last-child) {\n            margin-bottom: 2rem;\n          }\n\n          & strong {\n            font-family: 'Nunito';\n            font-size: 22px;\n            font-weight: 500;\n            text-align: left;\n            text-align: left !important;\n          }\n\n          & input,\n          textarea {\n            border: 1px solid ",
        ";\n            background-color: transparent;\n            width: 100%;\n            border-radius: 8px;\n            padding: 1.2rem 0.9rem;\n            outline: none;\n            font-size: 16px;\n            margin-top: 1rem;\n            color: ",
        ";\n            margin-bottom: 2rem;\n\n            ::placeholder {\n              color: ",
        ";\n            }\n          }\n\n          & textarea {\n            resize: none;\n            height: 127px;\n          }\n\n          &:last-child {\n            display: flex;\n            flex-direction: column;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 4rem 0;\n\n  & > div {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 100px;\n\n    & > div {\n      min-width: 800px;\n      display: flex;\n      flex-direction: column;\n\n      & h4 {\n        text-align: left;\n      }\n\n      & > div {\n        max-width: 800px;\n        &:nth-child(2) {\n          width: 100%;\n          min-height: 184px;\n          border: 1px solid ",
        ";\n          border-radius: 8px;\n          margin-bottom: 2rem;\n          padding: 1rem;\n\n          & > * {\n            height: 100%;\n          }\n        }\n      }\n    }\n\n    .swiper-wrapper {\n      justify-content: flex-start;\n    }\n\n    .card {\n      position: relative;\n      height: 100%;\n      width: 100%;\n\n      & img {\n        max-width: 184px;\n        min-height: auto;\n        background-color: #ffffff;\n      }\n      & > span:last-child {\n        position: absolute;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        z-index: 1;\n        top: 8px;\n        right: 8px;\n        height: 35px;\n        width: 35px;\n        border-radius: 50%;\n        background-color: rgba(2, 86, 130, 0.5);\n        cursor: pointer;\n      }\n    }\n\n    & > img {\n      position: absolute;\n\n      &:first-child {\n        bottom: 0;\n        left: 0;\n      }\n      &:last-child {\n        right: 0;\n      }\n    }\n\n    ",
        " {\n      padding: 0 34px;\n      max-width: 100% !important;\n      & > div {\n        min-width: auto;\n        width: 100%;\n      }\n      & > img {\n        position: absolute;\n        display: none;\n      }\n    }\n\n    ",
        " {\n    }\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 7rem;\n  width: 100%;\n\n  & > div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    .swiper-pagination {\n      position: absolute;\n      text-align: center;\n      transition: opacity 0.3s;\n      transform: translateZ(0);\n      z-index: 1;\n    }\n\n    & .card {\n      display: flex;\n      align-items: center;\n      justify-items: center;\n      cursor: pointer;\n\n      & img {\n        max-width: 280px;\n        min-height: auto;\n        background-color: #ffffff;\n      }\n    }\n\n    & > *:last-child {\n      max-width: 100%;\n      padding: 0 34px;\n    }\n\n    .swiper-button-next,\n    .swiper-button-prev {\n      position: absolute;\n      top: 35%;\n      width: 27px;\n      height: 54px;\n      margin-top: -22px;\n      z-index: 999;\n      cursor: pointer;\n      background: transparent;\n      border: none;\n    }\n\n    .swiper-button-next:before,\n    .swiper-button-prev:before {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      width: 26px;\n      height: 26px;\n      border-top: 3px solid #333;\n      border-right: 3px solid #333;\n      transform-origin: center center;\n    }\n\n    .swiper-button-next:before {\n      transform: translate(-50%, -50%) rotate(45deg);\n      margin-left: -2.5rem;\n    }\n\n    .swiper-button-prev:before {\n      transform: translate(-50%, -50%) rotate(-135deg);\n      margin-left: 2.5rem;\n    }\n\n    @media (min-width: 601px) {\n      .swiper-button-next:not(.swiper-button-disabled),\n      .swiper-button-prev:not(.swiper-button-disabled) {\n        display: block !important;\n      }\n    }\n  }\n  .swiper-wrapper {\n    display: flex;\n    justify-content: ",
        ";\n    align-items: center;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: -7rem;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  background-color: #fff;\n  height: 7rem;\n  box-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.5);\n  transition: all 0.3s;\n  width: 100%;\n\n  & > div {\n    max-width: 130em;\n\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    & > div {\n      display: flex;\n    }\n\n    & strong {\n      margin-right: 2rem;\n      font-size: 16px;\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  & > div {\n    width: 646px;\n\n    & label {\n      font-family: 'Nunito';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 20px;\n    }\n\n    input,\n    textarea {\n      border: 1px solid ",
        ";\n      background-color: transparent;\n      width: 100%;\n      border-radius: 8px;\n      padding: 1.2rem 0.9rem;\n      outline: none;\n      font-size: 16px;\n      margin-top: 1rem;\n      color: ",
        ";\n      resize: none;\n      margin: 30px 0;\n\n      ::placeholder {\n        color: ",
        ";\n      }\n    }\n\n    & textarea {\n      height: 127px;\n    }\n  }\n\n  ",
        " {\n    & > div {\n      width: auto;\n      min-width: 300px;\n    }\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin: 14rem 0;\n  & h2 {\n    text-align: center !important;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  text-align: center;\n  color: inherit !important;\n  font-family: inherit !important;\n  font-size: inherit !important;\n  font-style: inherit !important;\n  border: solid 1px transparent;\n  outline: none;\n  max-width: 1200px;\n  resize: none;\n\n  &::-webkit-scrollbar {\n    display: none; /* Hide scrollbar */\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n\n  & > li {\n    display: flex;\n    align-items: center;\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 220px;\n  margin: 0.8rem;\n  padding: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  display: flex;\n\n  img {\n    max-width: 60px;\n    margin: 5px;\n  }\n\n  p {\n    color: #6b6b6b;\n  }\n\n  @media (max-width: 768px) {\n    justify-content: space-evenly;\n    margin: 0.4rem;\n    width: 40%;\n\n    img {\n      max-width: 55px;\n      margin: 5px;\n    }\n  }\n\n  strong {\n    font-weight: bold;\n    font-size: 15px;\n  }\n\n  span {\n    font-weight: bold;\n    font-size: 15px;\n    color: #77c277;\n  }\n\n  @media (max-width: 500px) {\n    width: 80%;\n  }\n\n  ",
        " {\n    width: 100% !important;\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n\n  max-width: 100%;\n  padding: 20px;\n\n  h2 {\n    font-family: 'P22 Mackinac Pro';\n    color: #174f68;\n    margin-top: 35px;\n    font-size: 27px;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  min-width: 600px;\n\n  & > div {\n    :first-child {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  ",
        " {\n    min-width: 100% !important;\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed !important;\n  z-index: 999;\n  background-color: #fff;\n  width: 100%;\n  height: fit-content;\n  padding: 10px;\n  transition: all 0.3s;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: #000;\n  display: none;\n\n  & > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n\n    &:first-child {\n      font-size: 23px;\n      color: #174f68 !important;\n      display: flex;\n      flex-direction: column;\n    }\n\n    & strong {\n      margin: 0 5px;\n    }\n\n    & svg {\n      fill: #000;\n      color: #000;\n      font-size: 16px;\n    }\n  }\n\n  ",
        " {\n    display: flex;\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 5rem;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px;\n  border-radius: 8px;\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}



var styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b073139f-0"
})(styles_templateObject(), function(param) {
    var background = param.background;
    return "".concat(background);
}, function(param) {
    var background = param.background;
    return background ? background : "#fff";
});
var Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-b073139f-1"
})(styles_templateObject1(), function(param) {
    var fontColor = param.fontColor;
    return fontColor;
}, (0,media/* media */.B)("<=tablet"));
var SecondNavBar = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b073139f-2"
})(_templateObject2(), function(param) {
    var fontColor = param.fontColor;
    return fontColor ? fontColor : "#174F68";
}, (0,media/* media */.B)("<=tablet"));
var Footer = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-b073139f-3"
})(_templateObject3(), function(param) {
    var bgColor = param.bgColor;
    return bgColor ? bgColor : "#174F68";
}, function(param) {
    var fontColor = param.fontColor;
    return fontColor ? fontColor : "#fff";
}, (0,media/* media */.B)("<=tablet"));
var AsideNavigation = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    componentId: "sc-b073139f-4"
})(_templateObject4(), function(param) {
    var toggle = param.toggle;
    return toggle ? 0 : -100;
});
var ContainerShare = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b073139f-5"
})(_templateObject5());
var CenterLinks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b073139f-6"
})(_templateObject6());
var LogoItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b073139f-7"
})(_templateObject7());
var InstaLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b073139f-8"
})(_templateObject8());
var MobileInstaLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b073139f-9"
})(_templateObject9());
var Content = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    componentId: "sc-b073139f-10"
})(_templateObject10(), function(param) {
    var color = param.color;
    return color;
}, function(param) {
    var bgColor = param.bgColor;
    return bgColor ? bgColor : "#fff6e8";
}, function(param) {
    var color = param.color;
    return color ? color : "#fff";
}, (0,media/* media */.B)("<=tablet"), (0,media/* media */.B)("<=phone"), function(param) {
    var hasImage = param.hasImage;
    return hasImage ? "150px" : "250px";
}, function(param) {
    var hasImage = param.hasImage;
    return hasImage ? "100% auto !important" : "auto";
}, function(param) {
    var hasImage = param.hasImage;
    return hasImage ? "176px" : "350px";
}, function(param) {
    var hasImage = param.hasImage;
    return hasImage ? "cover !important" : "auto";
}, function(param) {
    var hasImage = param.hasImage;
    return hasImage ? "260px" : "450px";
}, function(param) {
    var hasImage = param.hasImage;
    return hasImage ? "100% auto !important" : "auto";
}, function(param) {
    var hasImage = param.hasImage;
    return hasImage ? "300px" : "500px";
});
var HeaderSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b073139f-11"
})(_templateObject11(), function(param) {
    var cover = param.cover, bgColor = param.bgColor, hasCover = param.hasCover;
    return !cover ? "background-color: ".concat(bgColor, ";display: flex; justify-content: center; align-items:center; margin-bottom: 1rem !important;") : hasCover ? "background: linear-gradient(transparent 40%,".concat(bgColor, " 92%,").concat(bgColor, " 100%), url(") + cover + ") !important;display: flex; justify-content: center; align-items:center; margin-bottom: 1rem !important;" : "background: url(" + cover + ") !important;display: flex; justify-content: center; align-items:center; margin-bottom: 1rem !important;";
}, function(param) {
    var mobileCover = param.mobileCover, bgColor = param.bgColor;
    return !mobileCover ? "background-color: ".concat(bgColor, ";display: flex; justify-content: center; align-items:center; margin-bottom: 1rem !important;") : "background: linear-gradient(transparent 40%,".concat(bgColor, " 92%,").concat(bgColor, " 100%), url(") + mobileCover + ") !important;display: flex; justify-content: center; align-items:center; margin-bottom: 1rem !important;";
}, function(param) {
    var hasCover = param.hasCover;
    return !hasCover ? "auto" : "100% auto !important";
}, function(param) {
    var hasCover = param.hasCover;
    return !hasCover ? "300px" : "200px";
});
var FooterSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b073139f-12"
})(_templateObject12(), function(param) {
    var imageURL = param.imageURL, bgColor = param.bgColor;
    return !imageURL ? "background-color: ".concat(bgColor, ";display: flex; justify-content: center; align-items:center") : "background-image: url(".concat(imageURL, ") !important;display: flex; justify-content: center; align-items:center;}");
}, function(param) {
    var mobileCover = param.mobileCover, bgColor = param.bgColor;
    return !mobileCover ? "background-color: ".concat(bgColor, ";display: flex; justify-content: center; align-items:center") : "background-image: url(".concat(mobileCover, ") !important;display: flex; justify-content: center; align-items:center;}");
});
var MessageSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b073139f-13"
})(_templateObject13());
var Switch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b073139f-14"
})(_templateObject14());
var CentredSpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b073139f-15"
})(_templateObject15());
var TitleSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b073139f-16"
})(_templateObject16(), (0,media/* media */.B)("<=tablet"), (0,media/* media */.B)("<=phone"));
var ProgressiveSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b073139f-17"
})(_templateObject17(), function(param) {
    var fontColor = param.fontColor;
    return fontColor ? fontColor : "#174F68";
}, function(param) {
    var fontColor = param.fontColor;
    return fontColor ? fontColor : "#174F68";
}, function(param) {
    var fontColor = param.fontColor;
    return fontColor ? fontColor : "#174F68";
}, function(param) {
    var fontColor = param.fontColor;
    return fontColor ? fontColor : "#174F68";
}, function(param) {
    var fontColor = param.fontColor;
    return fontColor ? fontColor : "#174F68";
}, function(param) {
    var fontColor = param.fontColor;
    return fontColor ? fontColor : "#174F68";
}, (0,media/* media */.B)("<=tablet"), (0,media/* media */.B)("<=phone"));
var ContainerDonationSuggestions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b073139f-18"
})(_templateObject18(), (0,media/* media */.B)("<=tablet"), (0,media/* media */.B)("<=phone"));
var ButtonDonnationValue = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-b073139f-19"
})(_templateObject19(), function(param) {
    var selected = param.selected;
    return selected ? "solid 1px #fff" : "none";
});
var TaxValuesTextNote = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b073139f-20"
})(_templateObject20());
var QuotasSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b073139f-21"
})(_templateObject21(), function(param) {
    var fontColor = param.fontColor;
    return fontColor ? fontColor : "#174F68";
}, function(param) {
    var fontColor = param.fontColor;
    return fontColor ? fontColor : "#174F68";
}, function(param) {
    var fontColor = param.fontColor;
    return fontColor ? fontColor : "#8b8ee8";
});
{
/**
export const SupportersSection = styled.section<{ color: string }>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 80%;
`;

*/ }var PrivateAlbumSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b073139f-22"
})(_templateObject22(), function(param) {
    var borderColor = param.borderColor;
    return borderColor ? borderColor : "rgba(139, 142, 232, 0.5)";
}, (0,media/* media */.B)("<=tablet"), (0,media/* media */.B)("<=phone"));
var PublicAlbumSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b073139f-23"
})(_templateObject23(), function(param) {
    var pageSize = param.pageSize;
    return pageSize > 1 ? "flex-start !important" : "center !important";
});
var SubmitContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b073139f-24"
})(_templateObject24());
var SendMessageSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b073139f-25"
})(_templateObject25(), function(param) {
    var fontColor = param.fontColor;
    return fontColor || "#8b8ee899";
}, function(param) {
    var fontColor = param.fontColor;
    return fontColor || "#8b8ee899";
}, function(param) {
    var fontColor = param.fontColor;
    return fontColor || "#8b8ee899";
}, (0,media/* media */.B)("<=tablet"));
var ShareSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b073139f-26"
})(_templateObject26());
var EditableContent = (0,styled_components_browser_esm/* default */.ZP)(react_textarea_autosize_browser_esm/* default */.Z).withConfig({
    componentId: "sc-b073139f-27"
})(_templateObject27());
var SupporterList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-b073139f-28"
})(_templateObject28());
var SupporterItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-b073139f-29"
})(_templateObject29(), (0,media/* media */.B)("<=tablet"));
var Supporters = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b073139f-30"
})(_templateObject30());
var DonateInputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b073139f-31"
})(_templateObject31(), (0,media/* media */.B)("<=tablet"));
var FixedDonateResumeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b073139f-32"
})(_templateObject32(), (0,media/* media */.B)("<=tablet"));
var PaginateContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b073139f-33"
})(_templateObject33());
var VerificationContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b073139f-34"
})(_templateObject34());

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(40993);
// EXTERNAL MODULE: ./node_modules/advanced-cropper/types/index.js
var types = __webpack_require__(62245);
// EXTERNAL MODULE: ./node_modules/advanced-cropper/extensions/absolute-zoom/index.js + 4 modules
var absolute_zoom = __webpack_require__(74254);
// EXTERNAL MODULE: ./node_modules/react-icons/im/index.esm.js
var im_index_esm = __webpack_require__(53990);
// EXTERNAL MODULE: ./node_modules/react-icons/vsc/index.esm.js
var vsc_index_esm = __webpack_require__(14578);
// EXTERNAL MODULE: ./node_modules/react-mobile-cropper/dist/index.esm-bundler.js
var index_esm_bundler = __webpack_require__(84803);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-mobile-cropper/dist/style.css
var style = __webpack_require__(64066);
;// CONCATENATED MODULE: ./components/ModalImageCropper.tsx

function ModalImageCropper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  border-radius: 10px;\n  gap: 5px;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .modal {\n    user-select: none;\n    min-width: 300px;\n\n    &__zoom {\n      position: absolute;\n      top: 15px;\n      user-select: none;\n      display: flex;\n      flex-direction: row;\n\n      & span {\n        cursor: pointer;\n\n        &:first-child {\n          margin-right: 1rem;\n        }\n        &:last-child {\n          margin-left: 1rem;\n        }\n      }\n    }\n\n    &_noImage {\n      padding: 1rem;\n      font-size: 4em;\n      text-align: center;\n      color: rgba(255, 255, 255, 0.2);\n    }\n    &__cropper-wrapper {\n      background: black;\n    }\n\n    &__cropper {\n      color: #174F68; // cropper's color: ;\n      max-height: 70vh;\n      height: 70vh;\n      width: 70vw;\n      margin: 0;\n    }\n\n    &__cropper-background {\n      background: black;\n    }\n\n    &__cropper-wrapper {\n      position: relative;\n    }\n\n    &__buttons-wrapper {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      bottom: 0;\n      padding: 1rem;\n      flex: 1;\n\n      & > *:first-child {\n        margin-right: 1rem;\n      }\n    }\n\n    &_reset_button {\n      white-space: pre-wrap;\n      & span {\n        display: block !important;\n        margin-left: 0.3rem;\n      }\n    }\n    &__button {\n      border: none;\n      outline: solid transparent;\n      padding: 12px 25px;\n      height: 42px;\n      background-color: #174F68;\n      font-family: 'Nunito';\n      font-style: normal;\n      font-weight: 500;\n      font-size: 16px;\n      outline: none;\n      border: none;\n      border-radius: 8px;\n      color: white;\n      cursor: pointer;\n      transition: background 0.5s;\n      display: flex;\n      align-items: center;\n\n      &:hover,\n      &:focus {\n        background: #20232a;\n      }\n      input {\n        display: none;\n      }\n\n      &_cancel {\n        background-color: #20232a;\n        margin-left: 1rem;\n\n        &:hover,\n        &:focus {\n          background: #ff44008c;\n        }\n      }\n    }\n  }\n  @media (max-width: 450px) {\n    .modal__buttons-wrapper {\n      flex-direction: column;\n      gap: 5px;\n\n      & > * {\n        width: 100%;\n        margin: 0 !important;\n      }\n    }\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n\n    .modal__button {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      & > *:first-child,\n      & > *:nth-child(2) {\n        margin-right: 0;\n      }\n\n      & > span {\n        display: none;\n      }\n    }\n    .modal__cropper {\n      width: 90vw;\n    }\n  }\n"
    ]);
    ModalImageCropper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalImageCropper_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #174F68;\n  font-weight: bold;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-size: 10pt;\n  margin: 0 1rem;\n  text-transform: capitalize;\n\n  & > *:first-child {\n    margin-right: 0.5rem;\n  }\n"
    ]);
    ModalImageCropper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalImageCropper_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  height: 100%;\n  padding: 5px;\n"
    ]);
    ModalImageCropper_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalImageCropper_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 1rem;\n"
    ]);
    ModalImageCropper_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalImageCropper_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 1rem;\n"
    ]);
    ModalImageCropper_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModalImageCropper_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 1rem;\n"
    ]);
    ModalImageCropper_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}











function ModalImageCropper(param) {
    var open = param.open, cropperSize = param.cropperSize, url = param.url, resizable = param.resizable, setOpen = param.setOpen, onCropImage = param.onCropImage, onReset = param.onReset;
    var inputRef = (0,react.useRef)(null);
    var cropperRef = (0,react.useRef)();
    var ref = (0,react.useState)(), image = ref[0], setImage = ref[1];
    var ref1 = (0,react.useState)(), photo = ref1[0], setPhoto = ref1[1];
    var ref2 = (0,react.useState)(), cropImageState = ref2[0], setCropImageState = ref2[1];
    var ref3 = (0,react.useState)(), cropImageSettings = ref3[0], setCropImageSettings = ref3[1];
    var ref4 = (0,react.useState)(0), mult = ref4[0], setMult = ref4[1];
    var zoom = function(action) {
        var ref;
        if (!(cropImageState && cropImageSettings)) return;
        var absoluteZoom = (0,absolute_zoom/* getAbsoluteZoom */.x)(cropImageState, cropImageSettings);
        var z_size = 0.01;
        cropperRef === null || cropperRef === void 0 ? void 0 : (ref = cropperRef.current) === null || ref === void 0 ? void 0 : ref.zoomImage((0,absolute_zoom/* getZoomFactor */.i)(cropImageState, cropImageSettings, action === "Out" ? absoluteZoom - z_size * mult : absoluteZoom + z_size));
        if (action === "Out") {
            setMult(function(prev) {
                return prev + 1;
            });
        } else setMult(0);
    };
    var reset = function() {
        var ref;
        return cropperRef === null || cropperRef === void 0 ? void 0 : (ref = cropperRef.current) === null || ref === void 0 ? void 0 : ref.reset();
    };
    var onUpload = function() {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };
    var onCrop = function() {
        var cropper = cropperRef.current;
        if (cropper) {
            var canvas = cropper.getCanvas();
            if (canvas) {
                var dataURL = canvas.toDataURL();
                fetch(dataURL).then(function(res) {
                    return res.blob();
                }).then(function(blob) {
                    var type = photo === null || photo === void 0 ? void 0 : photo.type.split("/");
                    var file = new File([
                        blob
                    ], "".concat(Date.now(), "-").concat(Math.random().toString(36).substring(2, 8), ".").concat(type === null || type === void 0 ? void 0 : type[(type === null || type === void 0 ? void 0 : type.length) - 1]), {
                        type: photo === null || photo === void 0 ? void 0 : photo.type
                    });
                    handlerCloseModal();
                    onCropImage === null || onCropImage === void 0 ? void 0 : onCropImage(file, dataURL);
                    setImage("");
                });
            }
        }
    };
    var onLoadImage = function(event) {
        var file = event.target.files && event.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
            setPhoto(file);
        }
        event.target.value = "";
    };
    (0,react.useEffect)(function() {
        // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        return function() {
            if (image) {
                URL.revokeObjectURL(image);
            }
        };
    }, [
        image
    ]);
    var customStyles = {
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-40%",
            transform: "translate(-50%, -50%)",
            padding: 0
        },
        overlay: {
            zIndex: 999
        }
    };
    var handlerCloseModal = function() {
        setOpen(function(prev) {
            return !prev;
        });
        setImage("");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        isOpen: open,
        style: customStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalImageCropper_Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalImageCropper_Content, {
                children: [
                    image || url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal__cropper-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm_bundler/* Cropper */.fl, {
                            ref: cropperRef,
                            className: "modal__cropper",
                            backgroundClassName: "modal__cropper-background",
                            src: image ? image : url,
                            /*maxWidth={cropperSize.width}
                maxHeight={cropperSize.height}*/ imageRestriction: types/* ImageRestriction.none */.i.none,
                            onChange: function(param) {
                                var getSettings = param.getSettings, getState = param.getState;
                                setCropImageSettings(getSettings());
                                setCropImageState(getState());
                            },
                            stencilProps: {
                                movable: false,
                                resizable: !!resizable
                            },
                            defaultSize: {
                                width: 50,
                                height: 50
                            },
                            defaultCoordinates: {
                                left: cropperSize.width * -1 / 2,
                                top: cropperSize.height * -1 / 2,
                                width: cropperSize.width * 4,
                                height: cropperSize.height * 4
                            }
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal__buttons-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "modal__button",
                                onClick: onUpload,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        ref: inputRef,
                                        type: "file",
                                        accept: "image/*",
                                        onChange: onLoadImage
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Camera, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Inserir foto"
                                    })
                                ]
                            }),
                            image ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "modal__button",
                                onClick: onCrop,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CropAndSave, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Recortar e Salvar"
                                    })
                                ]
                            }) : onReset ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "modal__button modal_reset_button",
                                onClick: onReset,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Revert, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Desfazer"
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: handlerCloseModal,
                                className: "modal__button modal__button_cancel",
                                children: "Cancelar"
                            }),
                            image || url ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "modal__zoom",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        onClick: function() {
                                            return zoom("Out");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(im_index_esm/* ImZoomOut */._JP, {
                                            size: 20,
                                            color: "#fff"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResetButton, {
                                        onClick: reset,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Revert, {
                                                size: 20
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                                children: "Desfazer"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        onClick: function() {
                                            return zoom("In");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(im_index_esm/* ImZoomIn */.BJw, {
                                            size: 20,
                                            color: "#fff"
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        })
    });
}
var ModalImageCropper_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91a7098d-0"
})(ModalImageCropper_templateObject());
var ResetButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-91a7098d-1"
})(ModalImageCropper_templateObject1());
var ModalImageCropper_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91a7098d-2"
})(ModalImageCropper_templateObject2());
var Camera = (0,styled_components_browser_esm/* default */.ZP)(fa_index_esm/* FaCamera */.Dmm).withConfig({
    componentId: "sc-91a7098d-3"
})(ModalImageCropper_templateObject3());
var CropAndSave = (0,styled_components_browser_esm/* default */.ZP)(fa_index_esm/* FaCrop */.oqy).withConfig({
    componentId: "sc-91a7098d-4"
})(ModalImageCropper_templateObject4());
var Revert = (0,styled_components_browser_esm/* default */.ZP)(vsc_index_esm/* VscDebugStepBack */.khq).withConfig({
    componentId: "sc-91a7098d-5"
})(ModalImageCropper_templateObject5());

// EXTERNAL MODULE: ./components/PaymentSecurity.tsx
var PaymentSecurity = __webpack_require__(57259);
// EXTERNAL MODULE: ./node_modules/react-circular-progressbar/dist/styles.css
var styles = __webpack_require__(86422);
// EXTERNAL MODULE: ./node_modules/react-circular-progressbar/dist/index.esm.js
var dist_index_esm = __webpack_require__(95774);
// EXTERNAL MODULE: ./utils/stringFormat.ts
var stringFormat = __webpack_require__(43620);
;// CONCATENATED MODULE: ./components/PoolProgressiveCard.tsx


function PoolProgressiveCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.15);\n  padding: 2rem;\n  width: 570px;\n  min-height: 438px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n\n  ",
        "\n\n  .progress-chart {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex: 1;\n    position: relative;\n\n    & > *:first-child {\n      font-family: 'Nunito';\n      width: 200px;\n      height: 200px;\n      font-weight: bold;\n      font-family: 24px;\n    }\n\n    .completed-badge-center {\n      position: absolute;\n      top: 40%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      z-index: 10;\n    }\n  }\n\n  .progress-stats {\n    display: flex;\n    flex-direction: row;\n    border-radius: 5px;\n    background-color: #0e26491a;\n    color: black;\n    margin-top: 1rem;\n\n    & > div {\n      display: flex;\n      flex-direction: column;\n      text-align: center;\n      flex: 1;\n      padding: 1rem;\n\n      & span {\n        font-family: 'Nunito';\n        font-size: 14px;\n        font-weight: normal;\n        text-align: center;\n      }\n      & strong {\n        font-family: 'Nunito';\n        font-size: 18px;\n        font-weight: 700;\n        line-height: 33px;\n        letter-spacing: 0em;\n        text-align: center;\n      }\n\n      &:nth-child(2) {\n        border-left: 1px solid #0e264933;\n        border-right: 1px solid #0e264933;\n      }\n    }\n  }\n\n  ",
        " {\n    width: 100%;\n    max-width: 380px;\n    min-height: 329px;\n    position: relative !important;\n    z-index: auto;\n    top: auto;\n\n    .progress-chart {\n      flex: 1;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n      \n      & > *:first-child {\n        width: 150px;\n        height: 150px;\n      }\n\n      .completed-badge-center {\n        position: absolute;\n        top: -10%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        z-index: 10;\n        img {\n          width: 150px !important;\n          height: 180px !important;\n          margin-bottom: 20px;\n        }\n      }\n    }\n\n    .progress-stats {\n      & span {\n        font-size: 12px !important;\n      }\n      & strong {\n        font-size: 14px !important;\n      }\n    }\n  }\n\n  ",
        " {\n    width: 300px;\n    min-height: 329px;\n\n    .progress-chart {\n      flex: 1;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n      \n      & > *:first-child {\n        width: 100px;\n        height: 100px;\n      }\n\n      .completed-badge-center {\n        position: absolute;\n        top: 15%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        z-index: 10;\n        \n        @media (max-width: 500px) {\n          img {\n            width: 100px !important;\n            height: 130px !important;\n            margin-bottom: 0px;\n          }\n        }\n      }\n    }\n\n    & * {\n      font-size: 100% !important;\n    }\n  }\n"
    ]);
    PoolProgressiveCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PoolProgressiveCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  padding: 1.5rem 0;\n  border-radius: 10px;\n  margin-top: 1.5rem;\n  font-weight: bold;\n  font-size: 12pt;\n  cursor: pointer !important;\n  color: white !important;\n\n  & > *:last-child {\n    margin-left: 1rem;\n  }\n"
    ]);
    PoolProgressiveCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PoolProgressiveCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 4rem;\n  display: none;\n  background-color: white;\n  color: black;\n  padding-bottom: 2rem;\n\n  ",
        " {\n    display: flex;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    z-index: 10;\n    flex-direction: column;\n\n    & > div {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      :last-child label {\n        align-self: center;\n        padding: 1rem 2rem;\n        color: white;\n        width: 100% !important;\n      }\n    }\n  }\n"
    ]);
    PoolProgressiveCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PoolProgressiveCard_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n  margin-bottom: 1rem;\n  gap: 10px;\n  min-height: 70px;\n"
    ]);
    PoolProgressiveCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var PoolProgressiveCard = function(param) {
    var data = param.data, fc = param.fontColor, isPrivate = param.isPrivate, _htmlFor = param.htmlFor, htmlFor = _htmlFor === void 0 ? "donateInput" : _htmlFor, isOnDescription = param.isOnDescription, amount = param.amount, onDonate = param.onDonate, onMounted = param.onMounted;
    var ref = (0,react.useState)(false), showFixedPoolState = ref[0], setHowFixedPoolState = ref[1];
    var convertValue = (0,react.useCallback)(function(value) {
        if (!value) return 0;
        else return value / 100;
    }, []);
    var fixedFee = (0,react.useMemo)(function() {
        return Number(data.raised) * Number(data.percentageFee) / 100;
    }, [
        data
    ]);
    var count = (0,react.useMemo)(function() {
        if ((!data.target || !data.raised) && data.raised !== 0 && data.target !== 0) return 0;
        return data.target && data.raised ? ((convertValue(data === null || data === void 0 ? void 0 : data.raised) - convertValue(fixedFee)) / parseFloat(data.target.toString()) * 100).toFixed(2) : 0;
    }, [
        data.target,
        data.raised,
        convertValue,
        fixedFee
    ]);
    var formatAmount = function(value) {
        return value === null || value === void 0 ? void 0 : value.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL"
        });
    };
    var fontColor = (0,react.useMemo)(function() {
        var targetColor = {
            r: 255,
            g: 255,
            b: 255
        };
        var distance = getColorDistance(targetColor, hexToRgb(fc || ""));
        if (distance < similarityThreshold) {
            return "#174F68";
        } else {
            return fc;
        }
    }, [
        fc
    ]);
    var isVerified = (0,react.useMemo)(function() {
        return (0,verification/* isPoolVerified */.t)(data);
    }, [
        data
    ]);
    (0,react.useEffect)(function() {
        var ref;
        onMounted({
            target: formatAmount((data === null || data === void 0 ? void 0 : data.target) || 0),
            raised: formatAmount(convertValue(data === null || data === void 0 ? void 0 : data.raised) - Number(convertValue(fixedFee))),
            supporters: (ref = data === null || data === void 0 ? void 0 : data.supporters) !== null && ref !== void 0 ? ref : 0
        });
    }, [
        convertValue,
        data === null || data === void 0 ? void 0 : data.raised,
        data === null || data === void 0 ? void 0 : data.supporters,
        data === null || data === void 0 ? void 0 : data.target,
        fixedFee,
        onMounted
    ]);
    (0,react.useEffect)(function() {
        setHowFixedPoolState(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PoolProgressiveCard_Container, {
        isOnDescription: isOnDescription,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeContainer, {
                children: isVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/verificada.png",
                    alt: "Verificada",
                    width: "40",
                    height: "40",
                    style: {
                        width: 100,
                        height: 70
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "progress-chart",
                children: [
                    data.active !== false && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* CircularProgressbar */.Ip, {
                        styles: (0,_object_spread/* default */.Z)({}, (0,dist_index_esm/* buildStyles */.y3)({
                            // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                            strokeLinecap: "butt",
                            // How long animation takes to go from one percentage to another, in seconds
                            pathTransitionDuration: 0.5,
                            // Colors
                            pathColor: fontColor ? fontColor : "#174F68",
                            textColor: fontColor ? fontColor : "#174F68",
                            trailColor: "#0E26491A",
                            backgroundColor: fontColor ? fontColor : "#174F68",
                            textSize: (0,stringFormat/* fontAdjusts */.p)("".concat(data.raised))
                        })),
                        maxValue: 100,
                        minValue: 0,
                        value: parseFloat(count.toString()),
                        text: "".concat(count, "%")
                    }),
                    data.active === false && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "completed-badge-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/concluida.png",
                            alt: "Conclu\xedda",
                            width: "40",
                            height: "40",
                            style: {
                                width: 185,
                                height: 230
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "progress-stats",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Meta: "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                style: {
                                    fontSize: (0,stringFormat/* fontAdjusts */.p)("".concat(data === null || data === void 0 ? void 0 : data.target), 18)
                                },
                                children: formatAmount((data === null || data === void 0 ? void 0 : data.target) || 0)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Total arrecadado: "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                style: {
                                    fontSize: (0,stringFormat/* fontAdjusts */.p)("".concat(data === null || data === void 0 ? void 0 : data.raised), 18)
                                },
                                children: formatAmount(convertValue(data === null || data === void 0 ? void 0 : data.raised) - Number(convertValue(fixedFee)))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Apoiadores"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                style: {
                                    fontSize: (0,stringFormat/* fontAdjusts */.p)("".concat(data === null || data === void 0 ? void 0 : data.supporters), 18)
                                },
                                children: (data === null || data === void 0 ? void 0 : data.supporters) || 0
                            })
                        ]
                    })
                ]
            }),
            !isPrivate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Donate, {
                        htmlFor: htmlFor,
                        bg: fontColor ? fontColor : "#174F68",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: data.active === false ? "Vaquinha Conclu\xedda" : "Doar agora"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "18",
                                height: "18",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                        clipPath: "url(#clip0_403_3007)",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M23.5351 14.7255C23.328 14.4739 23.0623 14.2771 22.7614 14.1523C22.4605 14.0274 22.1335 13.9784 21.8091 14.0094C20.0668 14.1472 18.3756 14.6641 16.854 15.524C15.3323 16.3839 14.017 17.5659 13.0001 18.9874V13.9104C14.3967 13.6732 15.6644 12.9499 16.5793 11.8685C17.4943 10.787 17.9975 9.417 18.0001 8.00045C18.0001 5.20745 16.0571 2.84845 14.1561 0.90945C13.5798 0.346296 12.806 0.0310059 12.0001 0.0310059C11.1943 0.0310059 10.4205 0.346296 9.84414 0.90945C7.94314 2.84845 6.00014 5.20745 6.00014 8.00045C6.00277 9.417 6.50601 10.787 7.42094 11.8685C8.33587 12.9499 9.6036 13.6732 11.0001 13.9104V18.9874C9.98325 17.5659 8.66795 16.3839 7.14632 15.524C5.62468 14.6641 3.93349 14.1472 2.19114 14.0094C1.86683 13.9786 1.53989 14.0277 1.23897 14.1525C0.938059 14.2773 0.672352 14.4741 0.465138 14.7255C0.259251 14.9699 0.115898 15.2608 0.0474331 15.5729C-0.0210313 15.8851 -0.0125527 16.2093 0.0721381 16.5175C2.11114 23.8554 11.5911 24.0005 11.9941 24.0005H12.0061C12.4061 24.0005 21.8901 23.8554 23.9291 16.5175C24.0133 16.2092 24.0215 15.885 23.9529 15.5729C23.8842 15.2608 23.7409 14.97 23.5351 14.7255ZM8.00014 8.00045C8.00014 5.34645 11.3181 2.28145 11.3381 2.26445C10.9731 3.20045 8.69314 8.90045 11.0001 9.00045C11.2654 9.00045 11.5197 8.89509 11.7072 8.70756C11.8948 8.52002 12.0001 8.26567 12.0001 8.00045C12.0756 6.22189 12.5029 4.47592 13.2571 2.86345C14.6881 4.39345 16.0001 6.15445 16.0001 8.00045C16.0001 9.06132 15.5787 10.0787 14.8286 10.8289C14.0784 11.579 13.061 12.0005 12.0001 12.0005C10.9393 12.0005 9.92186 11.579 9.17171 10.8289C8.42157 10.0787 8.00014 9.06132 8.00014 8.00045ZM2.00614 16.0005C3.80787 16.1464 5.53915 16.7654 7.02499 17.7949C8.51083 18.8243 9.69856 20.2278 10.4681 21.8635C7.97114 21.5175 3.20014 20.3004 2.00614 16.0005ZM13.5451 21.8615C14.321 20.2304 15.5091 18.83 16.9919 17.7988C18.4747 16.7676 20.201 16.1411 22.0001 15.9815C20.8061 20.2835 16.0461 21.5114 13.5451 21.8615Z",
                                            fill: "#ffffff"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                            id: "clip0_403_3007",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                width: "24",
                                                height: "24",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileDonateContainer, {
                        style: {
                            transition: "all .3s",
                            bottom: showFixedPoolState ? "-0.5rem" : "-15rem",
                            boxShadow: "0px 4px 20px 0px rgba(0,0,0,0.15)"
                        },
                        bg: fontColor ? fontColor : "#174F68",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Donate, {
                                htmlFor: htmlFor,
                                bg: fontColor ? fontColor : "#174F68",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: data.active === false ? "Vaquinha Conclu\xedda" : "Doar agora"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                clipPath: "url(#clip0_403_3007)",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M23.5351 14.7255C23.328 14.4739 23.0623 14.2771 22.7614 14.1523C22.4605 14.0274 22.1335 13.9784 21.8091 14.0094C20.0668 14.1472 18.3756 14.6641 16.854 15.524C15.3323 16.3839 14.017 17.5659 13.0001 18.9874V13.9104C14.3967 13.6732 15.6644 12.9499 16.5793 11.8685C17.4943 10.787 17.9975 9.417 18.0001 8.00045C18.0001 5.20745 16.0571 2.84845 14.1561 0.90945C13.5798 0.346296 12.806 0.0310059 12.0001 0.0310059C11.1943 0.0310059 10.4205 0.346296 9.84414 0.90945C7.94314 2.84845 6.00014 5.20745 6.00014 8.00045C6.00277 9.417 6.50601 10.787 7.42094 11.8685C8.33587 12.9499 9.6036 13.6732 11.0001 13.9104V18.9874C9.98325 17.5659 8.66795 16.3839 7.14632 15.524C5.62468 14.6641 3.93349 14.1472 2.19114 14.0094C1.86683 13.9786 1.53989 14.0277 1.23897 14.1525C0.938059 14.2773 0.672352 14.4741 0.465138 14.7255C0.259251 14.9699 0.115898 15.2608 0.0474331 15.5729C-0.0210313 15.8851 -0.0125527 16.2093 0.0721381 16.5175C2.11114 23.8554 11.5911 24.0005 11.9941 24.0005H12.0061C12.4061 24.0005 21.8901 23.8554 23.9291 16.5175C24.0133 16.2092 24.0215 15.885 23.9529 15.5729C23.8842 15.2608 23.7409 14.97 23.5351 14.7255ZM8.00014 8.00045C8.00014 5.34645 11.3181 2.28145 11.3381 2.26445C10.9731 3.20045 8.69314 8.90045 11.0001 9.00045C11.2654 9.00045 11.5197 8.89509 11.7072 8.70756C11.8948 8.52002 12.0001 8.26567 12.0001 8.00045C12.0756 6.22189 12.5029 4.47592 13.2571 2.86345C14.6881 4.39345 16.0001 6.15445 16.0001 8.00045C16.0001 9.06132 15.5787 10.0787 14.8286 10.8289C14.0784 11.579 13.061 12.0005 12.0001 12.0005C10.9393 12.0005 9.92186 11.579 9.17171 10.8289C8.42157 10.0787 8.00014 9.06132 8.00014 8.00045ZM2.00614 16.0005C3.80787 16.1464 5.53915 16.7654 7.02499 17.7949C8.51083 18.8243 9.69856 20.2278 10.4681 21.8635C7.97114 21.5175 3.20014 20.3004 2.00614 16.0005ZM13.5451 21.8615C14.321 20.2304 15.5091 18.83 16.9919 17.7988C18.4747 16.7676 20.201 16.1411 22.0001 15.9815C20.8061 20.2835 16.0461 21.5114 13.5451 21.8615Z",
                                                    fill: "#ffffff"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                    id: "clip0_403_3007",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        width: "24",
                                                        height: "24",
                                                        fill: "white"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_PoolProgressiveCard = (PoolProgressiveCard);
var PoolProgressiveCard_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7c29b993-0"
})(PoolProgressiveCard_templateObject(), function(param) {
    var isOnDescription = param.isOnDescription;
    return isOnDescription ? "position: fixed !important;top: 3rem; z-index: 10;" : "";
}, (0,media/* media */.B)("<=tablet"), (0,media/* media */.B)("<=phone"));
var Donate = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-7c29b993-1"
})(PoolProgressiveCard_templateObject1(), function(param) {
    var bg = param.bg;
    return bg;
});
var MobileDonateContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7c29b993-2"
})(PoolProgressiveCard_templateObject2(), (0,media/* media */.B)("<=tablet"));
var BadgeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7c29b993-3"
})(PoolProgressiveCard_templateObject3());

;// CONCATENATED MODULE: ./public/color-picker.png
/* harmony default export */ var color_picker = ({"src":"/_next/static/media/color-picker.53355ac3.png","height":20,"width":19,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAllBMVEVMaXH3YB7nqS8AllNlJ5L87Qc5n5s8g35gup1BS6dMuUgFqFqfyToBqJCRxjxX0r9BlH6t4FdZja8ApqgErPAGj9gKtu8IarZyb5/vHwWQJpHJJl7vJynO5k9Qc1/3lST3sBn5wRJe37kMsmAutpWV1UxIkIE1xLsCBCsRxf8QjM8WJjz1Ky+eOaCzgly5nl7/py7/2yBDUvImAAAAInRSTlMA9jAx4uL+/fgw87cw9bH9/f7+9rDzMbb+MbHzt/74sPO226elFQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEpJREFUeJwFwYUBgDAAA7AyJri7M9zh/+dIAMthrCeAakx+/XUE5qC5vHlb2KMUB38UhMu8CnkriDbhSe2skMR7kF1lDugppYWOH7ZvBT8u2svxAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/preview-photo.svg
var _rect, _circle, _path;
function preview_photo_extends() { return preview_photo_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, preview_photo_extends.apply(null, arguments); }

var SvgPreviewPhoto = function SvgPreviewPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", preview_photo_extends({
    width: 104,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.441,
    width: 100.564,
    height: 96,
    rx: 2.874,
    fill: "#BBB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.453,
    cy: 27.488,
    r: 4.79,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 80.098 19.436-24.781 12.876 24.781 34.65-54.92 35.075 54.92",
    stroke: "#DFE2EE",
    strokeWidth: 1.437
  })));
};

/* harmony default export */ var preview_photo = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTA0IiBoZWlnaHQ9Ijk2IiB2aWV3Qm94PSIwIDAgMTA0IDk2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSIxLjQ0MTQxIiB3aWR0aD0iMTAwLjU2NCIgaGVpZ2h0PSI5NiIgcng9IjIuODc0MjgiIGZpbGw9IiNCQkJCQkIiLz4KPGNpcmNsZSBjeD0iMjguNDUyNiIgY3k9IjI3LjQ4ODIiIHI9IjQuNzkwNDYiIGZpbGw9IiNEOUQ5RDkiLz4KPHBhdGggZD0iTTEgODAuMDk4TDIwLjQzNTYgNTUuMzE2OUwzMy4zMTE3IDgwLjA5OEw2Ny45NjE3IDI1LjE3NzdMMTAzLjAzNyA4MC4wOTgiIHN0cm9rZT0iI0RGRTJFRSIgc3Ryb2tlLXdpZHRoPSIxLjQzNzE0Ii8+Cjwvc3ZnPgo=");
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(40570);
// EXTERNAL MODULE: ./components/Seo.tsx + 2 modules
var Seo = __webpack_require__(57874);
// EXTERNAL MODULE: ./env.ts
var env = __webpack_require__(81431);
// EXTERNAL MODULE: ./contexts/PoolContext.tsx + 2 modules
var PoolContext = __webpack_require__(30836);
;// CONCATENATED MODULE: ./public/pool/default-header-bg-support.png
/* harmony default export */ var default_header_bg_support = ({"src":"/_next/static/media/default-header-bg-support.96131f24.png","height":694,"width":1041,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAXVBMVEXNb87/torAp7D/3cDjtamhZVJ8ZW3//8/45cjToIndtc6YbGXXvsiJgnWif5jAp5m0u/S8stKtp77PjIHLvMGCeW6xv+6trqCvmMPTubl7VU7ElIHWnniZhXadfav+wNO2AAAAG3RSTlMBRsximaDRDTVxWuyHJYRvSOJ6oDbbacSw9WXQ2EFwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAM0lEQVR4nAXBCQKAEAAAwSVC0klU+P8zzcBxPfELgKpnbsmAc7fW/4R9e1GzF5h9s6tcGDAdAfMNN+2OAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/pool/default-footer-bg.png
/* harmony default export */ var default_footer_bg = ({"src":"/_next/static/media/default-footer-bg.b6ce3dcd.png","height":396,"width":1920,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAJFBMVEUYerfqYkhkrjzFZ6/0WCxHo0PWmSiWgrsWgcVfOpUYh8Hsi52aBeboAAAADHRSTlMlKCaXeX1+MXx7fJuhOKTIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgYmRkZGdgYGBgZWPhZubk4gAAAaAARWrDEOMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./public/pool/default-header-mobile-bg-support.png
var default_header_mobile_bg_support = __webpack_require__(61911);
;// CONCATENATED MODULE: ./public/pool/default-footer-mobile-bg.png
/* harmony default export */ var default_footer_mobile_bg = ({"src":"/_next/static/media/default-footer-mobile-bg.46f2beb4.png","height":191,"width":430,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAPFBMVEXrNDgVir/2mpr3qrSDKo0ef7ktX6dMaXHvSkA+U6PFE4rTYbGUdrThkbruMkQsKInvdjbDiL/ajqrWqs1tx2KnAAAAFHRSTlNAgZGye0JDAHl7dI1WnHo/dqhbvgm8x1AAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAmSURBVHicY2CHAgYGBgYhHn42VgYOPmZhQRZORgYBDiZebi4WTgAROQEFBUv6TAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./node_modules/react-share/lib/index.js
var react_share_lib = __webpack_require__(12484);
// EXTERNAL MODULE: ./node_modules/use-clipboard-copy/dist/index.js
var dist = __webpack_require__(16248);
;// CONCATENATED MODULE: ./components/SocialShareModal.tsx




function SocialShareModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: ",
        ";\n  visibility: ",
        ";\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  text-align: left;\n  background: rgba(0, 0, 0, 0.5);\n  transition: opacity 0.5s ease;\n  z-index: 99999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & button {\n    color: #0088cc;\n    padding: 8px 30px;\n    background-color: transparent;\n    font-family: 'Nunito';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    outline: none;\n    border: none;\n    cursor: pointer;\n    font-weight: bold;\n\n    &[disabled] {\n      background-color: rgba(217, 217, 217, 1);\n    }\n  }\n\n  & > div {\n    border-radius: 1rem;\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    max-width: 90%;\n    & > div {\n      &:first-child {\n        align-self: center;\n        padding: 1.5rem;\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        gap: 10;\n        & > * {\n          margin: 0 0.5rem;\n        }\n      }\n      &:last-child {\n        position: relative;\n        margin: 1.5rem;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        font-size: 10pt;\n        & > div {\n          margin-top: 0;\n          background-color: #231f20;\n          color: white;\n          padding: 1rem;\n          border-radius: 0.5rem;\n          overflow: auto;\n\n          & * {\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            margin-right: 5rem;\n          }\n        }\n        & > *:last-child {\n          position: absolute;\n          right: 0;\n          background-color: white;\n          padding: 0.3rem 0.5rem;\n          margin-right: 0.3rem;\n          border-radius: 0.5rem;\n        }\n      }\n    }\n  }\n"
    ]);
    SocialShareModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var SocialShareModal = function(_param) {
    var open = _param.open, setOpen = _param.setOpen, args = (0,_object_without_properties/* default */.Z)(_param, [
        "open",
        "setOpen"
    ]);
    var ref = (0,dist.useClipboard)({
        copiedTimeout: 600
    }), copy = ref.copy, copied = ref.copied;
    var hadlerCopy = function(e) {
        copy(args.url);
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShareModal_Container, {
        onClick: function() {
            return setOpen(!open);
        },
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_share_lib.WhatsappShareButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
                            title: "Seja bem vindo a minha vaquinha:",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_share_lib.WhatsappIcon, {
                                size: 50,
                                round: true
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_share_lib.FacebookShareButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_share_lib.FacebookIcon, {
                                size: 50,
                                round: true
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_share_lib.TwitterShareButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_share_lib.TwitterIcon, {
                                size: 50,
                                round: true
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_share_lib.LinkedinShareButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_share_lib.LinkedinIcon, {
                                size: 50,
                                round: true
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_share_lib.TelegramShareButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_share_lib.TelegramIcon, {
                                size: 50,
                                round: true
                            })
                        }))
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: args.url
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: hadlerCopy,
                            children: copied ? "Copiado" : "Copiar"
                        })
                    ]
                })
            ]
        })
    });
};
var SocialShareModal_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e0bb544-0"
})(SocialShareModal_templateObject(), function(param) {
    var open = param.open;
    return open ? 1 : 0;
}, function(param) {
    var open = param.open;
    return open ? "visible" : "hidden";
});
/* harmony default export */ var components_SocialShareModal = (SocialShareModal);

;// CONCATENATED MODULE: ./hooks/useLetterCounter.ts

var useLetterCounter = function(maxLenght) {
    var ref = (0,react.useState)(""), word = ref[0], setWord = ref[1];
    var ref1 = (0,react.useState)(true), error = ref1[0], setError = ref1[1];
    var remaining = (0,react.useMemo)(function() {
        var length = maxLenght >= word.length ? maxLenght - word.length : 0;
        if (length > 0) setError(false);
        else setError(true);
        return length;
    }, [
        word,
        maxLenght
    ]);
    return {
        remaining: remaining,
        word: word,
        setWord: setWord,
        error: error,
        maxLenght: maxLenght
    };
};

;// CONCATENATED MODULE: ./components/FontEditor.tsx




function FontEditor_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: auto !important;\n\n  .tooltip-container {\n    display: flex;\n    position: relative;\n  }\n\n  .tooltip-label {\n    cursor: pointer;\n    z-index: 1;\n    font-family: sans-serif;\n    font-size: 16px;\n  }\n\n  .tooltip-content {\n    position: absolute;\n    margin-top: -70px;\n    background-color: transparent;\n    left: 50%;\n    transform: translate(-50%, 0);\n    min-height: 100px;\n  }\n\n  .tooltip-content-container {\n    display: flex;\n    flex-direction: flex;\n    gap: 0;\n    align-items: center;\n    background-color: white;\n    padding: 0.2rem 0;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    border-radius: 10px;\n    min-height: 50px;\n  }\n\n  .tooltip-content-container > * {\n    display: flex;\n    user-select: none;\n    text-wrap: nowrap;\n    padding: 0.2rem 0.5rem;\n    max-height: 48px;\n  }\n\n  .tooltip-content-container > *:last-child {\n    border-right: none;\n  }\n\n  .tooltip-custom-select {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    padding: 8px 12px;\n    font-size: 16px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 8px;\n    outline: none;\n    background: #fff\n      url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='rgba(0, 0, 0, 0.2)'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3Cpath fill='none' d='M0 0h24v24H0z'/%3E%3C/svg%3E\")\n      no-repeat right 12px center;\n    background-size: 16px;\n    background-color: #fff;\n    min-width: 80px;\n    height: 38px;\n  }\n\n  .tooltip-custom-select:hover {\n    border: 1px solid #3498db;\n    background: #fff\n      url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%233498db'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3Cpath fill='none' d='M0 0h24v24H0z'/%3E%3C/svg%3E\")\n      no-repeat right 12px center;\n    background-size: 16px;\n    background-color: #fff;\n  }\n\n  .tooltip-label-style {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    height: 38px;\n  }\n\n  .tooltip-label-bold {\n    color: #000 !important;\n    font-family: sans-serif !important;\n    font-weight: bold !important;\n    font-style: normal !important;\n  }\n\n  .tooltip-label-italic {\n    font-style: italic !important;\n    font-family: sans-serif !important;\n    font-weight: normal !important;\n    color: #000 !important;\n  }\n\n  .tooltip-label-underline {\n    position: relative;\n    text-decoration: underline !important;\n    font-family: sans-serif !important;\n    font-weight: normal !important;\n    color: #000 !important;\n    font-style: normal !important;\n  }\n\n  .tooltip-color-picker {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .tooltip-custom-color-input {\n    position: absolute;\n    padding: 0;\n    border: none;\n    outline: none;\n    appearance: none;\n    -webkit-appearance: none;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  .tooltip-color-preview {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 1px solid #ccc;\n    cursor: pointer;\n  }\n\n  @media only screen and (max-width: 767px) {\n    .tooltip-content {\n      position: fixed;\n      bottom: 0 !important;\n      background-color: rgba(0, 0, 0, 0.1);\n      width: 100vw;\n      height: 100vh;\n      z-index: 99999 !important;\n    }\n\n    .tooltip-content-container {\n      flex-direction: column;\n      padding: 0.5rem 1rem;\n    }\n\n    .tooltip-content-container > * {\n      border: none;\n    }\n\n    .tooltip-content-container {\n      display: grid;\n      grid-template-columns: 1fr auto;\n      grid-template-rows: auto;\n      position: absolute;\n      bottom: 0;\n      width: 100%;\n      border-radius: 0;\n    }\n\n    .tooltip-custom-select {\n      min-width: 100%;\n    }\n  }\n"
    ]);
    FontEditor_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var useTooltipController = function(args) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,react.useState)(false), toggle = ref6[0], setToggle = ref6[1];
    var ref7 = (0,react.useState)((args === null || args === void 0 ? void 0 : (ref = args.defaultValue) === null || ref === void 0 ? void 0 : ref.fontFamily) || ""), fontFamily = ref7[0], setFontFamily = ref7[1];
    var ref8 = (0,react.useState)((args === null || args === void 0 ? void 0 : (ref1 = args.defaultValue) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || 16), fontSize = ref8[0], setFontSize = ref8[1];
    var ref9 = (0,react.useState)((args === null || args === void 0 ? void 0 : (ref2 = args.defaultValue) === null || ref2 === void 0 ? void 0 : ref2.color) || "#000"), color = ref9[0], setColor = ref9[1];
    var ref10 = (0,react.useState)((args === null || args === void 0 ? void 0 : (ref3 = args.defaultValue) === null || ref3 === void 0 ? void 0 : ref3.fontWeight) || "normal"), fontWeight = ref10[0], setFontWeight = ref10[1];
    var ref11 = (0,react.useState)((args === null || args === void 0 ? void 0 : (ref4 = args.defaultValue) === null || ref4 === void 0 ? void 0 : ref4.fontStyle) || "normal"), fontStyle = ref11[0], setFontStyle = ref11[1];
    var ref12 = (0,react.useState)((args === null || args === void 0 ? void 0 : (ref5 = args.defaultValue) === null || ref5 === void 0 ? void 0 : ref5.textDecoration) || "none"), textDecoration = ref12[0], setTextDecoration = ref12[1];
    var ref13 = (0,react.useState)({
        Roboto: "Roboto+sans-serif",
        "Open Sans": "Open Sans+sans-serif",
        Lato: "Lato, sans-serif",
        Montserrat: "Montserrat, sans-serif",
        Poppins: "Poppins, sans-serif",
        "Source Sans Pro": "Source Sans Pro, sans-serif",
        Ubuntu: "Ubuntu, sans-serif",
        Oswald: "Oswald, sans-serif",
        "Roboto Condensed": "Roboto Condensed, sans-serif",
        "Playfair Display": "Playfair Display, serif",
        Merriweather: "Merriweather, serif",
        Quicksand: "Quicksand, sans-serif",
        "Josefin Sans": "Josefin Sans, sans-serif",
        "Montserrat Alternates": "Montserrat Alternates, sans-serif",
        Oxygen: "Oxygen, sans-serif",
        Raleway: "Raleway, sans-serif",
        "Titillium Web": "Titillium Web, sans-serif",
        "Varela Round": "Varela Round, sans-serif",
        Archivo: "Archivo, sans-serif",
        Cabin: "Cabin, sans-serif",
        "Advent Pro": "Advent Pro, cursive",
        "Black Ops One": "Black Ops One, cursive",
        Cookie: "Cookie, cursive",
        Dosis: "Dosis, cursive",
        "Great Vibes": "Great Vibes, cursive",
        "Indie Flower": "Indie Flower, cursive",
        "Kaushan Script": "Kaushan Script, cursive",
        Lobster: "Lobster, cursive",
        Pacifico: "Pacifico, cursive",
        Sacramento: "Sacramento, cursive"
    }), fonts = ref13[0], setFonts = ref13[1];
    var ref14 = (0,react.useState)({
        8: 8,
        9: 9,
        10: 10,
        11: 11,
        12: 12,
        14: 14,
        16: 16,
        18: 18,
        20: 20,
        22: 22,
        24: 24,
        26: 26,
        28: 28,
        36: 36,
        48: 48,
        72: 72
    }), sizes = ref14[0], setSizes = ref14[1];
    (0,react.useEffect)(function() {
        (args === null || args === void 0 ? void 0 : args.sizes) && setSizes(args.sizes);
        (args === null || args === void 0 ? void 0 : args.fonts) && setFonts(args.fonts);
    }, [
        args
    ]);
    var link = (0,react.useMemo)(function() {
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://fonts.googleapis.com/css?family=".concat(Object.keys(fonts).join("|"));
        return link;
    }, [
        fonts
    ]);
    (0,react.useEffect)(function() {
        document.head.appendChild(link);
        return function() {
            document.head.removeChild(link);
        };
    }, [
        link
    ]);
    var style = (0,react.useMemo)(function() {
        return {
            fontFamily: fontFamily,
            fontSize: fontSize,
            fontStyle: fontStyle,
            textDecoration: textDecoration,
            fontWeight: fontWeight,
            color: color
        };
    }, [
        fontFamily,
        fontSize,
        fontStyle,
        textDecoration,
        color,
        fontWeight
    ]);
    var toggleHandler = function(state) {
        return setToggle(function(prev) {
            return state !== undefined ? state : !prev;
        });
    };
    var containerProps = {
        className: "tooltip-container",
        onClick: (args === null || args === void 0 ? void 0 : args.fireEvent) === "click" ? function() {
            return toggleHandler(!toggle);
        } : undefined,
        onMouseOver: (args === null || args === void 0 ? void 0 : args.fireEvent) === "hover" ? function() {
            return toggleHandler(true);
        } : undefined,
        onDoubleClick: function() {
            return toggleHandler(false);
        }
    };
    var colorPreviewStyles = {
        backgroundColor: color
    };
    var tooltipHoverHandler = function() {
        return toggleHandler(true);
    };
    var fontFamilyHandler = function(e) {
        setFontFamily(e.target.value);
        toggleHandler(false);
    };
    var fontSizeHandler = function(e) {
        setFontSize(parseFloat(e.target.value));
        toggleHandler(false);
    };
    var colorHandler = function(e) {
        return setColor(e.target.value);
    };
    var fontWeightHandler = function() {
        return setFontWeight(function(prev) {
            return prev === "bold" ? "normal" : "bold";
        });
    };
    var textDecorationHandler = function() {
        return setTextDecoration(function(prev) {
            return prev === "underline" ? "none" : "underline";
        });
    };
    var fontStyleHandler = function() {
        return setFontStyle(function(prev) {
            return prev === "italic" ? "normal" : "italic";
        });
    };
    (0,react.useEffect)(function() {
        var ref;
        args === null || args === void 0 ? void 0 : (ref = args.onStyleChanged) === null || ref === void 0 ? void 0 : ref.call(args, style);
    }, [
        args,
        style
    ]);
    return {
        fonts: fonts,
        sizes: sizes,
        style: style,
        toggle: toggle,
        toggleHandler: toggleHandler,
        containerProps: containerProps,
        tooltipHoverHandler: tooltipHoverHandler,
        fontFamilyHandler: fontFamilyHandler,
        fontSizeHandler: fontSizeHandler,
        colorPreviewStyles: colorPreviewStyles,
        colorHandler: colorHandler,
        fontWeightHandler: fontWeightHandler,
        textDecorationHandler: textDecorationHandler,
        fontStyleHandler: fontStyleHandler
    };
};
/**
 * Primary UI component for user interaction
 */ function FontEditor(_param) {
    var label = _param.label, _withColor = _param.withColor, withColor = _withColor === void 0 ? true : _withColor, _withDecoration = _param.withDecoration, withDecoration = _withDecoration === void 0 ? true : _withDecoration, _withSize = _param.withSize, withSize = _withSize === void 0 ? true : _withSize, _fireEvent = _param.fireEvent, fireEvent = _fireEvent === void 0 ? "click" : _fireEvent, args = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "withColor",
        "withDecoration",
        "withSize",
        "fireEvent"
    ]);
    var ref = useTooltipController((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
        withColor: withColor,
        withDecoration: withDecoration,
        withSize: withSize,
        fireEvent: fireEvent
    })), fonts = ref.fonts, sizes = ref.sizes, toggle = ref.toggle, containerProps = ref.containerProps, tooltipHoverHandler = ref.tooltipHoverHandler, fontFamilyHandler = ref.fontFamilyHandler, fontSizeHandler = ref.fontSizeHandler, colorHandler = ref.colorHandler, colorPreviewStyles = ref.colorPreviewStyles, fontWeightHandler = ref.fontWeightHandler, textDecorationHandler = ref.textDecorationHandler, fontStyleHandler = ref.fontStyleHandler, toggleHandler = ref.toggleHandler, style = ref.style;
    var modal = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: toggle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onMouseOver: tooltipHoverHandler,
            className: "tooltip-content",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function(e) {
                    return e.stopPropagation();
                },
                className: "tooltip-content-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            style: {
                                fontFamily: "sans-serif",
                                textDecoration: "none",
                                fontWeight: "normal",
                                fontStyle: "normal"
                            },
                            value: style.fontFamily,
                            onChange: fontFamilyHandler,
                            className: "tooltip-custom-select",
                            children: Object.keys(fonts).map(function(item, key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    style: {
                                        fontFamily: fonts[item],
                                        textDecoration: "none",
                                        fontWeight: "normal",
                                        fontStyle: "normal"
                                    },
                                    label: item.toString(),
                                    value: fonts[item]
                                }, key);
                            })
                        })
                    }),
                    withSize && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            style: {
                                fontFamily: "sans-serif",
                                textDecoration: "none",
                                fontWeight: "normal",
                                fontStyle: "normal"
                            },
                            value: style.fontSize,
                            onChange: fontSizeHandler,
                            className: "tooltip-custom-select",
                            children: Object.keys(sizes).map(function(item, key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    style: {
                                        fontFamily: "sans-serif",
                                        textDecoration: "none",
                                        fontWeight: "normal",
                                        fontStyle: "normal"
                                    },
                                    label: item.toString(),
                                    value: sizes[item]
                                }, key);
                            })
                        })
                    }),
                    withDecoration && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tooltip-label-style",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                onClick: fontWeightHandler,
                                className: "tooltip-label tooltip-label-bold",
                                children: "B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                onClick: fontStyleHandler,
                                className: "tooltip-label tooltip-label-italic",
                                children: "i"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                onClick: textDecorationHandler,
                                className: "tooltip-label tooltip-label-underline",
                                children: "S"
                            })
                        ]
                    }),
                    withColor && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tooltip-color-picker",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                onChange: colorHandler,
                                type: "color",
                                className: "tooltip-custom-color-input"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: (0,_object_spread/* default */.Z)({}, colorPreviewStyles),
                                className: "tooltip-color-preview"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function() {
                            return toggleHandler(false);
                        },
                        style: {
                            marginRight: 10
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaTimes */.aHS, {
                            color: "red",
                            size: 20
                        })
                    })
                ]
            })
        })
    });
    var element = typeof label !== "string" && typeof label !== "number" ? /*#__PURE__*/ react.cloneElement(label, (0,_object_spread/* default */.Z)({
        className: "tooltip-label",
        style: style
    }, containerProps), /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            label.props.children,
            modal
        ]
    })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "tooltip-label",
        style: (0,_object_spread/* default */.Z)({}, style)
    }, containerProps), {
        children: [
            label,
            modal
        ]
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FontEditor_Container, {
        children: element
    });
}
var FontEditor_Container = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4e1b575d-0"
})(FontEditor_templateObject());

// EXTERNAL MODULE: ./utils/CurrencyFormat.ts
var CurrencyFormat = __webpack_require__(53790);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var react_player_lib = __webpack_require__(22004);
var react_player_lib_default = /*#__PURE__*/__webpack_require__.n(react_player_lib);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var io_index_esm = __webpack_require__(51649);
;// CONCATENATED MODULE: ./components/ModalPoolVideo.tsx

function ModalPoolVideo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 620px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0 !important;\n  background-color: #fff;\n  gap: 8px;\n\n  & > div {\n    &:first-child {\n      display: flex;\n      align-items: center;\n      padding: 0.5rem;\n\n      & div {\n        display: flex;\n        padding: 0.5rem;\n        font-size: 14pt;\n        width: 100%;\n        border-radius: 4px;\n        align-items: center;\n\n        & span {\n          &:first-child {\n            flex: 1;\n            color: ",
        ";\n            font-weight: bold;\n          }\n        }\n      }\n    }\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n"
    ]);
    ModalPoolVideo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function ModalPoolVideo(param) {
    var open = param.open, setOpen = param.setOpen, pool = param.pool;
    var customStyles = {
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            height: "100%",
            transform: "translate(-50%, -50%)",
            minWidth: "310px",
            maxWidth: "758px",
            maxHeight: "650px",
            padding: 0
        },
        overlay: {
            zIndex: 999,
            backgroundColor: "rgba(0,0,0,0.5)"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCAPTCHAContext/* ReCAPTCHAProvider */.g, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
            isOpen: open,
            style: customStyles,
            onRequestClose: function() {
                return setOpen(false);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalPoolVideo_Container, {
                bgColor: pool === null || pool === void 0 ? void 0 : pool.backgroundColor,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: pool === null || pool === void 0 ? void 0 : pool.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    onClick: function() {
                                        return setOpen(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io_index_esm/* IoMdCloseCircle */.mpJ, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((react_player_lib_default()), {
                        style: {
                            borderRadius: 10
                        },
                        url: pool === null || pool === void 0 ? void 0 : pool.videoUrl,
                        onEnded: function() {
                            return setOpen(false);
                        },
                        controls: true,
                        autoplay: true,
                        playing: true,
                        width: "100%",
                        height: "100%"
                    })
                ]
            })
        })
    });
}
var ModalPoolVideo_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-38de1ca4-0"
})(ModalPoolVideo_templateObject(), function(param) {
    var bgColor = param.bgColor;
    return bgColor !== null && bgColor !== void 0 ? bgColor : "#174f68";
});

// EXTERNAL MODULE: ./components/Pagination.tsx
var Pagination = __webpack_require__(56505);
// EXTERNAL MODULE: ./contexts/AuthContext.tsx + 1 modules
var AuthContext = __webpack_require__(52681);
;// CONCATENATED MODULE: ./utils/isPoolManagerUser.ts
function isPoolManagerUser(pool, userId) {
    var ref;
    if (userId == null) return false;
    var uid = String(userId).trim();
    if (!uid) return false;
    if (((ref = pool.manager) === null || ref === void 0 ? void 0 : ref.id) != null && String(pool.manager.id).trim() === uid) return true;
    var p = pool;
    if (p.managerId != null && String(p.managerId).trim() === uid) return true;
    if (p.userId != null && String(p.userId).trim() === uid) return true;
    if (p.ownerId != null && String(p.ownerId).trim() === uid) return true;
    return false;
}

// EXTERNAL MODULE: ./utils/supporterPaymentVia.ts
var supporterPaymentVia = __webpack_require__(33207);
;// CONCATENATED MODULE: ./components/ModalEndCampaign.tsx

function ModalEndCampaign_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  padding: 20px;\n  text-align: center;\n"
    ]);
    ModalEndCampaign_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalEndCampaign_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  \n  &:hover {\n    opacity: 0.7;\n  }\n"
    ]);
    ModalEndCampaign_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalEndCampaign_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Nunito', sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  color: #174f68;\n  margin-bottom: 20px;\n  margin-top: 10px;\n"
    ]);
    ModalEndCampaign_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalEndCampaign_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Nunito', sans-serif;\n  font-size: 16px;\n  color: #333;\n  line-height: 1.5;\n  margin-bottom: 30px;\n  text-align: center;\n"
    ]);
    ModalEndCampaign_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalEndCampaign_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    ModalEndCampaign_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModalEndCampaign_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Nunito', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 100px;\n  \n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n"
    ]);
    ModalEndCampaign_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ModalEndCampaign_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #f5f5f5;\n  color: #333;\n  border: 1px solid #ddd;\n  \n  &:hover {\n    background-color: #e9e9e9;\n  }\n"
    ]);
    ModalEndCampaign_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ModalEndCampaign_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #dc3545;\n  color: white;\n  \n  &:hover {\n    background-color: #c82333;\n  }\n"
    ]);
    ModalEndCampaign_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




function ModalEndCampaign(param) {
    var modalIsOpen = param.modalIsOpen, closeModal = param.closeModal, onConfirm = param.onConfirm;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        isOpen: modalIsOpen,
        shouldCloseOnEsc: true,
        shouldCloseOnOverlayClick: true,
        onRequestClose: closeModal,
        ariaHideApp: false,
        style: {
            overlay: {
                width: "100%",
                zIndex: 9999999,
                margin: "auto",
                backgroundColor: "rgba(0, 0, 0, 0.75)"
            },
            content: {
                maxWidth: "500px",
                maxHeight: "300px",
                width: "80%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "15px",
                margin: "100px auto",
                padding: "20px",
                position: "relative"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalEndCampaign_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                    onClick: closeModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiXCircle */.$Rx, {
                        color: "#174f68",
                        size: 30
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: "Encerrar Campanha"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                    children: 'Voc\xea est\xe1 encerrando est\xe1 campanha. Ao clicar em "Encerrar" Voc\xea n\xe3o receber\xe1 novas doa\xe7\xf5es, mas poder\xe1 resgatar o saldo em seu Painel Financeiro, se houver.'
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelButton, {
                            onClick: closeModal,
                            children: "Cancelar"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmButton, {
                            onClick: onConfirm,
                            children: "Encerrar"
                        })
                    ]
                })
            ]
        })
    });
}
var ModalEndCampaign_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2847bea-0"
})(ModalEndCampaign_templateObject());
var CloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-2847bea-1"
})(ModalEndCampaign_templateObject1());
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-2847bea-2"
})(ModalEndCampaign_templateObject2());
var Message = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2847bea-3"
})(ModalEndCampaign_templateObject3());
var ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2847bea-4"
})(ModalEndCampaign_templateObject4());
var ModalEndCampaign_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-2847bea-5"
})(ModalEndCampaign_templateObject5());
var CancelButton = (0,styled_components_browser_esm/* default */.ZP)(ModalEndCampaign_Button).withConfig({
    componentId: "sc-2847bea-6"
})(ModalEndCampaign_templateObject6());
var ConfirmButton = (0,styled_components_browser_esm/* default */.ZP)(ModalEndCampaign_Button).withConfig({
    componentId: "sc-2847bea-7"
})(ModalEndCampaign_templateObject7());

;// CONCATENATED MODULE: ./components/ModalEndCampaignSuccess.tsx

function ModalEndCampaignSuccess_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  padding: 20px;\n  text-align: center;\n"
    ]);
    ModalEndCampaignSuccess_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalEndCampaignSuccess_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  \n  &:hover {\n    opacity: 0.7;\n  }\n"
    ]);
    ModalEndCampaignSuccess_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalEndCampaignSuccess_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 20px;\n  margin-top: 10px;\n"
    ]);
    ModalEndCampaignSuccess_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalEndCampaignSuccess_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Nunito', sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  color: #28a745;\n  margin-bottom: 30px;\n"
    ]);
    ModalEndCampaignSuccess_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalEndCampaignSuccess_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    ModalEndCampaignSuccess_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModalEndCampaignSuccess_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Nunito', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 100px;\n  background-color: #174f68;\n  color: white;\n  \n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    background-color: #0d3a4f;\n  }\n"
    ]);
    ModalEndCampaignSuccess_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




function ModalEndCampaignSuccess(param) {
    var modalIsOpen = param.modalIsOpen, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        isOpen: modalIsOpen,
        shouldCloseOnEsc: true,
        shouldCloseOnOverlayClick: true,
        onRequestClose: closeModal,
        ariaHideApp: false,
        style: {
            overlay: {
                width: "100%",
                zIndex: 9999999,
                margin: "auto",
                backgroundColor: "rgba(0, 0, 0, 0.75)"
            },
            content: {
                maxWidth: "450px",
                maxHeight: "300px",
                width: "80%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "15px",
                margin: "100px auto",
                padding: "20px",
                position: "relative"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalEndCampaignSuccess_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalEndCampaignSuccess_CloseButton, {
                    onClick: closeModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiXCircle */.$Rx, {
                        color: "#174f68",
                        size: 30
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiCheckCircle */._rq, {
                        color: "#28a745",
                        size: 60
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalEndCampaignSuccess_Title, {
                    children: "Encerrada com sucesso"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalEndCampaignSuccess_ButtonContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton, {
                        onClick: closeModal,
                        children: "Voltar"
                    })
                })
            ]
        })
    });
}
var ModalEndCampaignSuccess_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b358bba5-0"
})(ModalEndCampaignSuccess_templateObject());
var ModalEndCampaignSuccess_CloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-b358bba5-1"
})(ModalEndCampaignSuccess_templateObject1());
var SuccessIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b358bba5-2"
})(ModalEndCampaignSuccess_templateObject2());
var ModalEndCampaignSuccess_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-b358bba5-3"
})(ModalEndCampaignSuccess_templateObject3());
var ModalEndCampaignSuccess_ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b358bba5-4"
})(ModalEndCampaignSuccess_templateObject4());
var BackButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-b358bba5-5"
})(ModalEndCampaignSuccess_templateObject5());

;// CONCATENATED MODULE: ./templates/pool/index.tsx

















































function sanitizeDisplayName(value) {
    if (typeof value !== "string") return "";
    var trimmed = value.trim();
    if (!trimmed) return "";
    return trimmed.replace(/\bundefined\b\s*[.,;:!?]*/gi, "").replace(/\s{2,}/g, " ").trim();
}
var PoolTemplate = function(param) {
    var _mode = param.mode, mode = _mode === void 0 ? "normal" : _mode, isGuest = param.isGuest, data = param.data;
    var sortObjectKeys = function sortObjectKeys(obj) {
        var sortedKeys = Object.keys(obj).sort();
        var sortedObject = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = sortedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                sortedObject[key] = obj[key];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return sortedObject;
    };
    var ref = (0,react.useState)(false), toggleMenu = ref[0], setToggleMenu = ref[1];
    var ref1 = (0,react.useState)(0), lastValue = ref1[0], setLastValue = ref1[1];
    var ref2 = (0,react.useState)([]), secondNav = ref2[0], setSecondNav = ref2[1];
    var ref3 = (0,react.useState)(""), footerBgImage = ref3[0], setFooterBgImage = ref3[1];
    var ref4 = (0,react.useState)(false), modalPoolViedo = ref4[0], setModalPoolViedo = ref4[1];
    var pickColor = (0,react.useRef)(null);
    var currentURL =  true ? window.location.href.split("/pool/").join("/") : 0;
    var ref5 = (0,PoolContext/* usePool */.AI)(), amount = ref5.amount, setAmount = ref5.setAmount, fetchAddedSupporters = ref5.fetchAddedSupporters, supportes = ref5.supportes, currentPage = ref5.currentPage, totalSupportesPages = ref5.totalSupportesPages, handleNextSupportesPage = ref5.handleNextSupportesPage, handlePreviewSupportesPage = ref5.handlePreviewSupportesPage;
    var ref6 = (0,react.useState)(1), publicAlbumPages = ref6[0], setPublicAlbumPages = ref6[1];
    var route = (0,router.useRouter)();
    var ref7 = usePoolState(isGuest, data), categories = ref7.categories, setSnapData = ref7.setSnapData, modalSocialShare = ref7.modalSocialShare, setModalSocialShare = ref7.setModalSocialShare, pool = ref7.pool, setPool = ref7.setPool, imgsPool = ref7.imgsPool, cropperSize = ref7.cropperSize, fontColor = ref7.fontColor, newBackGroundColor = ref7.newBackGroundColor, setNewBackGroundColor = ref7.setNewBackGroundColor, messageForm = ref7.messageForm, handlerPool = ref7.handlerPool, formData = ref7.formData, setFormData = ref7.setFormData, messages = ref7.messages, modalImageCropper = ref7.modalImageCropper, setModalImageCropper = ref7.setModalImageCropper, submit = ref7.submit, handlerCropImage = ref7.handlerCropImage, getCropperSize = ref7.getCropperSize, toggleModalImageCropper = ref7.toggleModalImageCropper, setMessageForm = ref7.setMessageForm, handlerSendMessage = ref7.handlerSendMessage, handleModerateMessage = ref7.handleModerateMessage, handleRemoveImg = ref7.handleRemoveImg, handlerShareData = ref7.handlerShareData, handlerTitleStyles = ref7.handlerTitleStyles, titleStyles = ref7.titleStyles, onCategoryChanged = ref7.onCategoryChanged, handleVerifySlug = ref7.handleVerifySlug, isValidSlug = ref7.isValidSlug, setSelectedCategoryId = ref7.setSelectedCategoryId, selectedCategoryId = ref7.selectedCategoryId, handlerEditPool = ref7.handlerEditPool, handleFinishCampaign = ref7.handleFinishCampaign;
    var ref8 = useLetterCounter(70), remaining = ref8.remaining, maxLenght = ref8.maxLenght, setTitleCounter = ref8.setWord;
    var setLoader = (0,Loader/* useLoader */.U)().setLoader;
    var user = (0,AuthContext/* useAuth */.a)().user;
    var isPoolRoute = route.pathname.startsWith("/pool");
    var showOwnerSupporterExtras = isPoolRoute && isPoolManagerUser(pool, user === null || user === void 0 ? void 0 : user.id);
    var ref9 = (0,react.useState)({}), supporterPaymentHints = ref9[0], setSupporterPaymentHints = ref9[1];
    var supporterDetailFetchAttemptedRef = (0,react.useRef)(new Set());
    var ref10 = (0,react.useState)(false), showEndCampaignModal = ref10[0], setShowEndCampaignModal = ref10[1];
    var ref11 = (0,react.useState)(false), showEndCampaignSuccessModal = ref11[0], setShowEndCampaignSuccessModal = ref11[1];
    var handleEndCampaignConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var success;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleFinishCampaign()
                        ];
                    case 1:
                        success = _state.sent();
                        if (success) {
                            setShowEndCampaignModal(false);
                            setShowEndCampaignSuccessModal(true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleEndCampaignConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var descriptionContainerRef = (0,react.useRef)(null);
    var ref12 = (0,react.useState)(false), isOnDescription = ref12[0], setIsOnDescription = ref12[1];
    var ref13 = (0,react.useState)(true), isOnBottom = ref13[0], setIsOnBottom = ref13[1];
    var ref14 = (0,react.useState)({
        raised: "0",
        supporters: 0,
        target: "0"
    }), progressiveData = ref14[0], setProgressiveData = ref14[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            var descriptionContainer = descriptionContainerRef.current;
            if (!descriptionContainer) return;
            var rect = descriptionContainer.getBoundingClientRect();
            var containerEnded = rect.top * -1 <= rect.height - 438;
            setIsOnDescription(rect.top <= 0 && containerEnded);
            setIsOnBottom(rect.bottom <= 438);
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var handleOnValueChange = function(value) {
        if (!value) {
            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                target: 0
            }));
            return;
        }
        if (Number.isNaN(Number(value.replace(",", ".")))) {
            return;
        }
        setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
            target: value
        }));
        setLastValue(parseFloat(value));
    };
    (0,react.useEffect)(function() {
        handlerResetPool();
    }, []);
    var handlerResetPool = (0,react.useCallback)(function() {
        if (data) {
            var ref, ref1;
            (data === null || data === void 0 ? void 0 : data.target) && setPool((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                target: parseFloat(data === null || data === void 0 ? void 0 : data.target.toString()) / 100
            }));
            (data === null || data === void 0 ? void 0 : data.backgroundColor) && setNewBackGroundColor(data === null || data === void 0 ? void 0 : data.backgroundColor);
            (data === null || data === void 0 ? void 0 : data.footer) && setFooterBgImage(data.footer);
            data.target && setLastValue(parseFloat(data.target.toString()) / 100);
            data.title && setTitleCounter(data.title);
            ((ref = data.category) === null || ref === void 0 ? void 0 : ref.id) && setSelectedCategoryId((ref1 = data.category) === null || ref1 === void 0 ? void 0 : ref1.id);
            data.id && fetchAddedSupporters(data.id);
            if (mode === "edit") {
                setFormData({
                    title: data.title,
                    slug: data.slug,
                    target: (parseFloat(data === null || data === void 0 ? void 0 : data.target) / 100).toString(),
                    city: data.city,
                    description: data.description,
                    fontColor: data.fontColor,
                    fontFamily: data.fontFamily,
                    fixedFee: data.fixedFee,
                    videoUrl: data.videoUrl,
                    state: data.state
                });
                setSnapData(JSON.stringify({
                    title: data.title,
                    slug: data.slug,
                    target: (parseFloat(data === null || data === void 0 ? void 0 : data.target) / 100).toString(),
                    city: data.city,
                    description: data.description,
                    fontColor: data.fontColor,
                    fontFamily: data.fontFamily,
                    fixedFee: data.fixedFee,
                    videoUrl: data.videoUrl,
                    state: data.state
                }));
            }
        }
        setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
    }, [
        data,
        fetchAddedSupporters,
        mode,
        setFormData,
        setLoader,
        setNewBackGroundColor,
        setPool,
        setSnapData,
        setTitleCounter
    ]);
    var nav = [
        {
            name: "Como funciona",
            anchor: "/faq"
        },
        {
            name: "Contato",
            anchor: "/contact"
        }, 
    ];
    var getSvgColor = (0,react.useMemo)(function() {
        return newBackGroundColor === "#fff6e8" ? undefined : newBackGroundColor;
    }, [
        newBackGroundColor
    ]);
    (0,react.useEffect)(function() {
        setSecondNav([
            {
                name: "Home",
                anchor: "/profile/user",
                newPage: false,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdHomeFilled */.SHD, {
                    size: 22,
                    color: getSvgColor
                }),
                iconMobile: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "18",
                    height: "18",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.3162 10.771V22.004C23.3154 22.3547 23.2202 22.6987 23.0407 22.9999C22.8613 23.3012 22.6041 23.5486 22.2961 23.7163C22.0137 23.872 21.6957 23.9515 21.3732 23.9471H15.5442C15.2865 23.9471 15.0394 23.8447 14.8572 23.6625C14.675 23.4803 14.5726 23.2332 14.5726 22.9755V17.1465C14.5726 16.8888 14.4703 16.6417 14.2881 16.4595C14.1059 16.2773 13.8588 16.175 13.6011 16.175H9.7151C9.45744 16.175 9.21034 16.2773 9.02814 16.4595C8.84595 16.6417 8.7436 16.8888 8.7436 17.1465V22.9755C8.7436 23.2332 8.64124 23.4803 8.45905 23.6625C8.27685 23.8447 8.02975 23.9471 7.77209 23.9471H1.94304C1.66741 23.9481 1.39474 23.8901 1.14339 23.777C0.892028 23.6639 0.6678 23.4983 0.485778 23.2913C0.169911 22.9181 -0.00234502 22.4444 2.41161e-05 21.9555V10.771C0.000109786 10.5014 0.0562971 10.2348 0.165013 9.98806C0.273729 9.74136 0.432594 9.51998 0.631504 9.338L10.3466 0.509424C10.7048 0.181734 11.1727 0 11.6581 0C12.1436 0 12.6115 0.181734 12.9697 0.509424L22.6847 9.338C22.8836 9.51998 23.0425 9.74136 23.1512 9.98806C23.2599 10.2348 23.3161 10.5014 23.3162 10.771Z",
                        fill: getSvgColor
                    })
                })
            },
            {
                name: "Compartilhar",
                anchor: "",
                newPage: true,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiShare2 */.PMT, {
                    color: getSvgColor,
                    size: 25
                }),
                iconMobile: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiShare2 */.PMT, {
                    color: getSvgColor,
                    size: 22
                })
            },
            {
                name: "Financeiro",
                anchor: "/profile/gifts-received?pooId=".concat(pool.id),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineMonetizationOn */.aox, {
                    size: 25,
                    color: getSvgColor
                }),
                iconMobile: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineMonetizationOn */.aox, {
                    size: 25,
                    color: getSvgColor
                }),
                newPage: false
            }, 
        ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getSvgColor
    ]);
    var socialNetwork = [
        {
            icon: "/instagram.png",
            url: "https://www.instagram.com/nossavaquinha/"
        }, 
    ];
    var date = new Date();
    var year = date.getFullYear();
    var handleOnValueAmountChange = function(value) {
        if (!value) {
            setAmount("");
            return;
        }
        if (Number.isNaN(Number(value.replace(",", ".")))) {
            return;
        }
        setAmount(value);
        setLastValue(parseFloat(value));
    };
    var ref15 = (0,react.useMemo)(function() {
        var headerFontColor = "#174F68";
        var headerBgColor = getSvgColor || "#174F68";
        var targetColor = {
            r: 255,
            g: 255,
            b: 255
        };
        var distance = getColorDistance(targetColor, hexToRgb(headerBgColor));
        if (distance < similarityThreshold) {
            return {
                headerBgColor: headerBgColor,
                headerFontColor: headerFontColor,
                distance: distance
            };
        } else {
            return {
                headerBgColor: !isGuest ? headerBgColor : "#ffffff",
                headerFontColor: !isGuest ? "#ffffff" : headerBgColor,
                distance: distance
            };
        }
    }, [
        getSvgColor,
        isGuest
    ]), headerFontColor = ref15.headerFontColor, headerBgColor = ref15.headerBgColor;
    var ref16 = (0,react.useMemo)(function() {
        var targetColor = hexToRgb("#fff6e8");
        var distance = getColorDistance(targetColor, hexToRgb(getSvgColor || ""));
        if (distance < similarityThreshold) {
            return {
                SecondHeaderbgColor: "#174F68",
                distance: distance
            };
        } else {
            return {
                SecondHeaderbgColor: "#fff6e8",
                distance: distance
            };
        }
    }, [
        getSvgColor
    ]), SecondHeaderbgColor = ref16.SecondHeaderbgColor, distance = ref16.distance;
    var auxColor = (0,react.useMemo)(function() {
        var targetColor = hexToRgb(newBackGroundColor);
        var distance = getColorDistance(targetColor, hexToRgb("#5cc9aa"));
        if (distance < 190 && newBackGroundColor !== "#fff6e8") {
            return "#000000";
        } else {
            return "#5cc9aa";
        }
    }, [
        newBackGroundColor
    ]);
    var forceNavigation = function(url) {
        window.location.href = url;
    };
    var handleDonate = (0,react.useCallback)(function() {
        if (pool.active === false) {
            (0,react_toastify_esm/* toast */.Am)("Esta campanha foi finalizada e n\xe3o aceita mais doa\xe7\xf5es", {
                type: "info"
            });
            return;
        }
        var value = parseFloat(amount);
        if (value < 20 || !value) (0,react_toastify_esm/* toast */.Am)("Valor inv\xe1lido! Doa\xe7\xe3o m\xednima R$ 20,00", {
            type: "error"
        });
        else forceNavigation("/payment/".concat(pool.slug, "?amount=").concat(value));
    }, [
        amount,
        pool.slug,
        pool.active
    ]);
    var handleDonateWithValue = (0,react.useCallback)(function(value) {
        if (pool.active === false) {
            (0,react_toastify_esm/* toast */.Am)("Esta campanha foi finalizada e n\xe3o aceita mais doa\xe7\xf5es", {
                type: "info"
            });
            return;
        }
        if (value < 20) {
            (0,react_toastify_esm/* toast */.Am)("Valor inv\xe1lido! Doa\xe7\xe3o m\xednima R$ 20,00", {
                type: "error"
            });
            return;
        }
        forceNavigation("/payment/".concat(pool.slug, "?amount=").concat(value));
    }, [
        pool.slug,
        pool.active
    ]);
    var isValidVideo = function(url) {
        return /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|e\/|user\/.*#p\/.*\/|.*[?&]v=)|youtu\.be\/|vimeo\.com\/)([a-zA-Z0-9_-]+)/.test(url);
    };
    (0,react.useEffect)(function() {
        pool.id && fetchAddedSupporters(pool.id, currentPage);
    }, [
        currentPage,
        fetchAddedSupporters,
        pool.id
    ]);
    (0,react.useEffect)(function() {
        supporterDetailFetchAttemptedRef.current.clear();
        setSupporterPaymentHints({});
    }, [
        pool.id,
        showOwnerSupporterExtras
    ]);
    (0,react.useEffect)(function() {
        if (!showOwnerSupporterExtras || !pool.id) return;
        supportes.forEach(function(s) {
            var id = s.id;
            if (!id || (0,supporterPaymentVia/* readSupporterPaymentRaw */.l)(s)) return;
            if (supporterDetailFetchAttemptedRef.current.has(id)) return;
            supporterDetailFetchAttemptedRef.current.add(id);
            apiClient/* api.get */.h.get("supporters/".concat(id)).then(function(param) {
                var data = param.data;
                var raw = (0,supporterPaymentVia/* readSupporterPaymentRaw */.l)(data);
                if (raw) setSupporterPaymentHints(function(prev) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, id, raw));
                });
            }).catch(function() {
                supporterDetailFetchAttemptedRef.current.delete(id);
            });
        });
    }, [
        supportes,
        showOwnerSupporterExtras,
        pool.id
    ]);
    var _title, _videoUrl, _videoUrl1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReCAPTCHAContext/* ReCAPTCHAProvider */.g, {
        children: [
            pool && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* SEO */.H, {
                    title: "Vaquinha ".concat(env/* EnvVars.SITE_NAME */.$.SITE_NAME, " - ").concat(pool.slug),
                    description: pool.description,
                    excludeTitleSuffix: true,
                    image: "".concat(env/* EnvVars.URL */.$.URL, "/Logo.svg")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPoolVideo, {
                pool: pool,
                open: modalPoolViedo,
                setOpen: setModalPoolViedo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SocialShareModal, {
                url: currentURL,
                title: pool.slug,
                open: modalSocialShare,
                setOpen: setModalSocialShare
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalEndCampaign, {
                modalIsOpen: showEndCampaignModal,
                closeModal: function() {
                    return setShowEndCampaignModal(false);
                },
                onConfirm: handleEndCampaignConfirm
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalEndCampaignSuccess, {
                modalIsOpen: showEndCampaignSuccessModal,
                closeModal: function() {
                    return setShowEndCampaignSuccessModal(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Container, {
                template: undefined,
                background: getSvgColor,
                theme: undefined,
                auxColor: auxColor,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            boxShadow: isGuest ? "0 0.1rem 0.4rem rgba(0,0,0,0.5)" : undefined,
                            background: !isGuest ? headerBgColor : headerFontColor
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                                fontColor: pool.id && !isGuest ? headerFontColor : isGuest ? headerBgColor : "#ffffff",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/",
                                            onClick: function(e) {
                                                e.preventDefault();
                                                forceNavigation("/");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: distance < similarityThreshold && !isGuest ? "/Logo.svg" : "/Logo-white.svg",
                                                height: 60,
                                                alt: "logo-white"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    children: nav.map(function(param, index) {
                                                        var name = param.name, anchor = param.anchor;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: name === "Compartilhar" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                onClick: function() {
                                                                    handlerShareData();
                                                                },
                                                                style: {
                                                                    color: headerFontColor
                                                                },
                                                                children: "Compartilhar"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: anchor,
                                                                onClick: function(e) {
                                                                    e.preventDefault();
                                                                    forceNavigation(anchor);
                                                                },
                                                                style: {
                                                                    color: headerFontColor
                                                                },
                                                                rel: "noreferrer",
                                                                children: name
                                                            })
                                                        }, index);
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return setToggleMenu(function(prev) {
                                                        return !prev;
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    height: 16,
                                                    width: 30,
                                                    src: "/menu.png",
                                                    alt: ""
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isGuest && /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondNavBar, {
                                style: {
                                    backgroundColor: SecondHeaderbgColor
                                },
                                theme: undefined,
                                fontColor: getSvgColor,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: secondNav.map(function(param, index) {
                                                var name = param.name, anchor = param.anchor, icon = param.icon, iconMobile = param.iconMobile, newPage = param.newPage;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: name === "Compartilhar" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerShare, {
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        onClick: function() {
                                                            handlerShareData();
                                                        },
                                                        children: [
                                                            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: icon
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Compartilhar"
                                                            }),
                                                            iconMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: iconMobile
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: anchor,
                                                        onClick: function(e) {
                                                            e.preventDefault();
                                                            newPage ? window.open(anchor, "_blank") : forceNavigation(anchor);
                                                        },
                                                        rel: "noreferrer",
                                                        children: [
                                                            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: icon
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: name
                                                            }),
                                                            iconMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: iconMobile
                                                            })
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AsideNavigation, {
                                theme: undefined,
                                toggle: toggleMenu,
                                onClick: function() {
                                    return setToggleMenu(function(prev) {
                                        return !prev;
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                    onClick: function(e) {
                                        return e.stopPropagation();
                                    },
                                    style: {
                                        backgroundColor: "#174f68",
                                        color: "#FFF6E8"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: "Menu"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: nav.map(function(param, index) {
                                                var name = param.name, anchor = param.anchor;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: anchor,
                                                        onClick: function(e) {
                                                            e.preventDefault();
                                                            forceNavigation(anchor);
                                                        },
                                                        rel: "noreferrer",
                                                        style: {
                                                            color: "#FFF6E8"
                                                        },
                                                        children: name
                                                    })
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        auxColor: auxColor,
                        color: fontColor,
                        bgColor: newBackGroundColor,
                        hasImage: !!pool.cover,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSection, {
                                cover: pool.cover || default_header_bg_support.src,
                                bgColor: newBackGroundColor,
                                mobileCover: pool.cover || default_header_mobile_bg_support/* default.src */.Z.src,
                                hasCover: !!pool.cover,
                                children: [
                                    !isGuest && /*#__PURE__*/ (0,jsx_runtime.jsx)(InsertImageButton, {
                                        onClick: function() {
                                            return toggleModalImageCropper("cover");
                                        },
                                        label: "Alterar imagem de capa",
                                        arrowPosition: "up"
                                    }),
                                    !isGuest && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalImageCropper, {
                                            cropperSize: getCropperSize(),
                                            onCropImage: function(file, url) {
                                                if (cropperSize === "footer" && url) {
                                                    setFooterBgImage(url);
                                                } else if (cropperSize === "cover") {
                                                    setPool((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pool), {
                                                        cover: url
                                                    }));
                                                }
                                                handlerCropImage(file);
                                            },
                                            open: modalImageCropper,
                                            setOpen: setModalImageCropper,
                                            resizable: false
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSection, {
                                style: {
                                    fontFamily: titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.fontFamily,
                                    color: titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.color,
                                    fontWeight: titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.fontWeight,
                                    fontStyle: titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.fontStyle,
                                    textDecoration: titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.textDecoration
                                },
                                children: (pool.title || formData.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FontEditor, {
                                    fireEvent: isGuest ? "none" : "click",
                                    defaultValue: {
                                        fontSize: "62.6726px",
                                        fontFamily: "inherit",
                                        color: "inherit",
                                        fontWeight: "inherit",
                                        fontStyle: "inherit",
                                        textDecoration: "inherit"
                                    },
                                    withSize: false,
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        children: [
                                            !isGuest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EditableContent, {
                                                defaultValue: pool.title,
                                                value: formData.title,
                                                onChange: function(e) {
                                                    setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                                        title: e.target.value
                                                    }));
                                                    setTitleCounter(e.target.value);
                                                },
                                                onClick: function(e) {
                                                    e.stopPropagation();
                                                },
                                                maxLength: 70
                                            }) : (_title = formData.title) !== null && _title !== void 0 ? _title : pool.title,
                                            !isGuest && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    marginLeft: "2rem",
                                                    cursor: "pointer",
                                                    alignItems: "center",
                                                    gap: 10
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        backgroundColor: "inherit",
                                                        border: "solid 4px " + fontColor + "11",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        flexDirection: "column",
                                                        padding: "1rem",
                                                        borderRadius: "50%",
                                                        height: 60,
                                                        width: 60
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaRegEdit */.ffH, {
                                                            color: fontColor,
                                                            height: 25,
                                                            width: 25,
                                                            style: {
                                                                marginLeft: 0
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            style: {
                                                                fontFamily: "Nunito",
                                                                fontSize: 12,
                                                                color: fontColor
                                                            },
                                                            children: "Editar"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    onStyleChanged: function(styles) {
                                        if (JSON.stringify(sortObjectKeys(styles)) !== JSON.stringify(sortObjectKeys({
                                            fontSize: "62.6726px",
                                            fontFamily: "inherit",
                                            color: "inherit",
                                            fontWeight: "inherit",
                                            fontStyle: "inherit",
                                            textDecoration: "inherit"
                                        }))) handlerTitleStyles(styles);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressiveSection, {
                                fontColor: fontColor,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        !isGuest ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "T\xedtulo da vaquinha"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            defaultValue: pool ? pool.title : undefined,
                                                            value: formData.title,
                                                            onChange: function(e) {
                                                                setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                                                    title: e.target.value
                                                                }));
                                                                setTitleCounter(e.target.value);
                                                            },
                                                            maxLength: maxLenght,
                                                            placeholder: "Ex. Ajuda para comprar ve\xedculo de trabalho"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            style: {
                                                                marginTop: ".5rem"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                                style: {
                                                                    fontSize: "11pt",
                                                                    color: remaining <= 10 ? "red" : auxColor
                                                                },
                                                                children: [
                                                                    "Caracteres restantes: ",
                                                                    remaining
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                            children: [
                                                                "V\xeddeo",
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                    style: {
                                                                        fontSize: "11pt"
                                                                    },
                                                                    children: "(opcional)"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                position: "relative"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "url",
                                                                    defaultValue: pool ? pool.videoUrl : undefined,
                                                                    value: formData.videoUrl,
                                                                    onChange: function(e) {
                                                                        setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                                                            videoUrl: e.target.value
                                                                        }));
                                                                    },
                                                                    placeholder: "Url do v\xeddeo do youtube ou vimeo"
                                                                }),
                                                                isValidVideo((_videoUrl = formData.videoUrl) !== null && _videoUrl !== void 0 ? _videoUrl : "") && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    onClick: function() {
                                                                        return setModalPoolViedo(true);
                                                                    },
                                                                    className: "player-button",
                                                                    title: "Reproduzir v\xeddeo",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineVideoLibrary */.qHP, {})
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "Categoria"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                            onChange: onCategoryChanged,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    selected: true,
                                                                    hidden: true,
                                                                    children: "Selecione uma categoria"
                                                                }),
                                                                categories.map(function(item, index) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        selected: item.id === selectedCategoryId,
                                                                        value: item.id,
                                                                        children: item.name
                                                                    }, index);
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "Localiza\xe7\xe3o"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                                onChange: function(e) {
                                                                    if (e.target.value) setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                                                        state: e.target.value
                                                                    }));
                                                                },
                                                                value: mode === "edit" ? formData.state : undefined,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "",
                                                                        disabled: true,
                                                                        selected: true,
                                                                        hidden: true,
                                                                        children: "Selecione um estado"
                                                                    }),
                                                                    states.map(function(item, index) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            selected: item.value === pool.state,
                                                                            value: item.value,
                                                                            children: item.label
                                                                        }, index);
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                            children: [
                                                                "Personalizar endere\xe7o do meu site",
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                    style: {
                                                                        fontSize: "11pt"
                                                                    },
                                                                    children: "(opcional)"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            defaultValue: pool ? pool.slug : undefined,
                                                            value: formData.slug,
                                                            onBlur: function(e) {
                                                                if (e.currentTarget.value !== pool.slug) handleVerifySlug(e.currentTarget.value);
                                                            },
                                                            onChange: function(e) {
                                                                if (!/^[a-zA-Z0-9]+$/.test(e.target.value) && e.target.value !== "") return;
                                                                setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                                                    slug: e.target.value
                                                                }));
                                                            },
                                                            style: !isValidSlug ? {
                                                                border: "solid 1px red",
                                                                color: "red"
                                                            } : undefined,
                                                            placeholder: "Digite um ou dois nomes sem espa\xe7o e sem acentos"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                color: "red",
                                                                marginTop: "1rem",
                                                                display: !isValidSlug ? "block" : "none"
                                                            },
                                                            children: "Slug indispon\xedvel ou inv\xe1lido! Por favor, escolha outro."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "column"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            style: {
                                                                fontSize: "11pt",
                                                                backgroundColor: newBackGroundColor,
                                                                marginRight: ".5rem",
                                                                opacity: 0.8
                                                            },
                                                            children: "O endere\xe7o do seu site ser\xe1:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                            style: {
                                                                fontSize: "11pt",
                                                                color: auxColor,
                                                                overflowWrap: "anywhere"
                                                            },
                                                            children: [
                                                                "https://nossavaquinha.com.br/",
                                                                formData.slug
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "Valor a ser arrecadado"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.ZP, {
                                                            placeholder: "R$ 0,00",
                                                            defaultValue: mode === "edit" ? pool.target : undefined,
                                                            onFocus: function() {
                                                                setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                                                    target: ""
                                                                }));
                                                            },
                                                            onBlur: function() {
                                                                setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                                                    target: "".concat(lastValue, ",00")
                                                                }));
                                                            },
                                                            onValueChange: handleOnValueChange,
                                                            value: formData.target,
                                                            allowDecimals: true,
                                                            decimalScale: 2,
                                                            decimalSeparator: ",",
                                                            decimalsLimit: 2,
                                                            allowNegativeValue: false,
                                                            intlConfig: {
                                                                locale: "pt-br",
                                                                currency: "BRL"
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "Mensagem de apresenta\xe7\xe3o"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                            defaultValue: pool ? pool.description : undefined,
                                                            value: formData.description,
                                                            placeholder: "Conte brevemente sua hist\xf3ria e solicite apoio",
                                                            onChange: function(e) {
                                                                setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                                                    description: e.target.value
                                                                }));
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        pool.id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: pool.slug ? "/" + pool.slug : "/#",
                                                                        target: "_blank",
                                                                        rel: "noreferrer",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            disabled: mode !== "edit",
                                                                            children: "Ver seu site"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        onClick: function() {
                                                                            handlerShareData();
                                                                        },
                                                                        disabled: mode !== "edit",
                                                                        children: "Compartilhar"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                position: "relative"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                onClick: function(e) {
                                                                    (pickColor === null || pickColor === void 0 ? void 0 : pickColor.current).click();
                                                                },
                                                                className: "button-color",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                        ref: pickColor,
                                                                        onChange: function(e) {
                                                                            setNewBackGroundColor(e.target.value);
                                                                            pickColor.current.value = "";
                                                                        },
                                                                        type: "color",
                                                                        list: "presetColors"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("datalist", {
                                                                        id: "presetColors",
                                                                        children: colors.map(function(item, index) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                children: item
                                                                            }, index);
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "picker-svg",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: color_picker,
                                                                            alt: "color-picker"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "Editar\xa0cor"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                isGuest && isValidVideo((_videoUrl1 = pool.videoUrl) !== null && _videoUrl1 !== void 0 ? _videoUrl1 : "") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        position: "relative",
                                                        alignItems: "center",
                                                        marginBottom: "3rem"
                                                    },
                                                    onClick: function() {
                                                        return setModalPoolViedo(true);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                position: "relative",
                                                                top: 0,
                                                                left: 0,
                                                                margin: 0
                                                            },
                                                            className: "player-button",
                                                            title: "Reproduzir v\xeddeo",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineVideoLibrary */.qHP, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                marginLeft: "1rem",
                                                                cursor: "pointer"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    style: {
                                                                        color: fontColor,
                                                                        fontSize: "2em",
                                                                        lineHeight: 1
                                                                    },
                                                                    children: "V\xeddeo"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                    children: "Clique para reproduzir o v\xeddeo da vaquinha."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    ref: descriptionContainerRef,
                                                    style: {
                                                        overflowWrap: "anywhere",
                                                        textAlign: "justify"
                                                    },
                                                    children: pool.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PoolProgressiveCard, {
                                                    isOnDescription: isOnDescription,
                                                    isOnBottom: isOnBottom,
                                                    isPrivate: !isGuest,
                                                    fontColor: getSvgColor,
                                                    data: pool,
                                                    amount: Number(amount),
                                                    onDonate: handleDonate,
                                                    onMounted: function(data) {
                                                        return setProgressiveData(data);
                                                    }
                                                }),
                                                isPoolManagerUser(pool, user === null || user === void 0 ? void 0 : user.id) && mode === "edit" && pool.active !== false && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        marginTop: "20px",
                                                        textAlign: "center",
                                                        width: "95%"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        onClick: function() {
                                                            return setShowEndCampaignModal(true);
                                                        },
                                                        style: {
                                                            backgroundColor: "#dc3545",
                                                            color: "white",
                                                            border: "none",
                                                            padding: "10px 20px",
                                                            borderRadius: "5px",
                                                            cursor: "pointer",
                                                            fontSize: "14px",
                                                            fontWeight: "bold",
                                                            transition: "background-color 0.3s ease",
                                                            width: "90%"
                                                        },
                                                        onMouseOver: function(e) {
                                                            return e.target.style.backgroundColor = "#c82333";
                                                        },
                                                        onMouseOut: function(e) {
                                                            return e.target.style.backgroundColor = "#dc3545";
                                                        },
                                                        children: "Encerrar Campanha"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            isGuest && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuotasSection, {
                                        fontColor: fontColor,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: "Fa\xe7a uma doa\xe7\xe3o"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerDonationSuggestions, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDonnationValue, {
                                                        selected: amount === "20",
                                                        onClick: function() {
                                                            setAmount("20");
                                                            handleDonateWithValue(20);
                                                        },
                                                        children: (0,CurrencyFormat/* formatarValorParaReais */.v)(2000)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDonnationValue, {
                                                        selected: amount === "30",
                                                        onClick: function() {
                                                            setAmount("30");
                                                            handleDonateWithValue(30);
                                                        },
                                                        children: (0,CurrencyFormat/* formatarValorParaReais */.v)(3000)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDonnationValue, {
                                                        selected: amount === "40",
                                                        onClick: function() {
                                                            setAmount("40");
                                                            handleDonateWithValue(40);
                                                        },
                                                        children: (0,CurrencyFormat/* formatarValorParaReais */.v)(4000)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDonnationValue, {
                                                        selected: amount === "50",
                                                        onClick: function() {
                                                            setAmount("50");
                                                            handleDonateWithValue(50);
                                                        },
                                                        children: (0,CurrencyFormat/* formatarValorParaReais */.v)(5000)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDonnationValue, {
                                                        selected: amount === "60",
                                                        onClick: function() {
                                                            setAmount("60");
                                                            handleDonateWithValue(60);
                                                        },
                                                        children: (0,CurrencyFormat/* formatarValorParaReais */.v)(6000)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDonnationValue, {
                                                        selected: amount === "70",
                                                        onClick: function() {
                                                            setAmount("70");
                                                            handleDonateWithValue(70);
                                                        },
                                                        children: (0,CurrencyFormat/* formatarValorParaReais */.v)(7000)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDonnationValue, {
                                                        selected: amount === "100",
                                                        onClick: function() {
                                                            setAmount("100");
                                                            handleDonateWithValue(100);
                                                        },
                                                        children: (0,CurrencyFormat/* formatarValorParaReais */.v)(10000)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDonnationValue, {
                                                        selected: amount === "200",
                                                        onClick: function() {
                                                            setAmount("200");
                                                            handleDonateWithValue(200);
                                                        },
                                                        children: (0,CurrencyFormat/* formatarValorParaReais */.v)(20000)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDonnationValue, {
                                                        selected: amount === "300",
                                                        onClick: function() {
                                                            setAmount("300");
                                                            handleDonateWithValue(300);
                                                        },
                                                        children: (0,CurrencyFormat/* formatarValorParaReais */.v)(30000)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDonnationValue, {
                                                        selected: amount === "500",
                                                        onClick: function() {
                                                            setAmount("500");
                                                            handleDonateWithValue(500);
                                                        },
                                                        children: (0,CurrencyFormat/* formatarValorParaReais */.v)(50000)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDonnationValue, {
                                                        selected: amount === "700",
                                                        onClick: function() {
                                                            setAmount("700");
                                                            handleDonateWithValue(700);
                                                        },
                                                        children: (0,CurrencyFormat/* formatarValorParaReais */.v)(70000)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDonnationValue, {
                                                        selected: amount === "1000",
                                                        onClick: function() {
                                                            setAmount("1000");
                                                            handleDonateWithValue(1000);
                                                        },
                                                        children: (0,CurrencyFormat/* formatarValorParaReais */.v)(100000)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DonateInputContainer, {
                                                            style: {
                                                                marginBottom: "0rem"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: "Digite aqui o valor de sua doa\xe7\xe3o"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.ZP, {
                                                                    id: "donateInput",
                                                                    placeholder: "R$ 0,00",
                                                                    onFocus: function() {
                                                                        setAmount("");
                                                                    },
                                                                    onValueChange: handleOnValueAmountChange,
                                                                    value: amount,
                                                                    allowDecimals: true,
                                                                    decimalScale: 2,
                                                                    decimalSeparator: ",",
                                                                    decimalsLimit: 2,
                                                                    min: 20,
                                                                    max: 10000,
                                                                    allowNegativeValue: false,
                                                                    intlConfig: {
                                                                        locale: "pt-br",
                                                                        currency: "BRL"
                                                                    },
                                                                    style: {
                                                                        marginBottom: "0rem"
                                                                    }
                                                                }),
                                                                (0,verification/* isPoolVerified */.t)(pool) && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerificationContainer, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "/verificada.png",
                                                                        alt: "Verificada",
                                                                        width: "40",
                                                                        height: "40",
                                                                        style: {
                                                                            width: 200,
                                                                            height: 150
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            style: {
                                                                marginTop: "10px"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                onClick: handleDonate,
                                                                children: pool.active ? "Quero doar" : "Campanha encerrada"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxValuesTextNote, {
                                        children: "*Valores sem impostos"
                                    })
                                ]
                            }),
                            (isGuest || showOwnerSupporterExtras) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Supporters, {
                                color: headerFontColor,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Apoiadores"
                                    }),
                                    supportes.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            flex: 1,
                                            flexDirection: "column"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupporterList, {
                                                children: supportes.map(function(item, index) {
                                                    var ref, ref1;
                                                    var hinted = item.id && supporterPaymentHints[item.id] ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                                        payment_method: supporterPaymentHints[item.id]
                                                    }) : item;
                                                    var viaLine = showOwnerSupporterExtras ? (0,supporterPaymentVia/* supporterPaymentViaLine */.z)(hinted) : null;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SupporterItem, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                style: {
                                                                    marginRight: 8
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    style: {
                                                                        backgroundColor: "white",
                                                                        padding: 4,
                                                                        borderRadius: 8
                                                                    },
                                                                    src: "/vaquinha.png",
                                                                    alt: "porquinho"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                children: sanitizeDisplayName(item.name)
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: item.paidAt && new Date(parseInt(item.paidAt)).toLocaleDateString()
                                                                            }),
                                                                            viaLine && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: viaLine
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: item.splitAmount && ((ref1 = parseFloat(((ref = (item.splitAmount + pool.fixedFee) / 100) === null || ref === void 0 ? void 0 : ref.toString()) || "")) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString("pt-br", {
                                                                            style: "currency",
                                                                            currency: "BRL"
                                                                        }))
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginateContainer, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                                    onPress: function() {
                                                        return fetchAddedSupporters(pool.id);
                                                    },
                                                    currentPage: currentPage !== null && currentPage !== void 0 ? currentPage : 1,
                                                    totalPages: totalSupportesPages !== null && totalSupportesPages !== void 0 ? totalSupportesPages : 0,
                                                    onNextPage: function() {
                                                        return pool.id && (handleNextSupportesPage === null || handleNextSupportesPage === void 0 ? void 0 : handleNextSupportesPage(pool.id));
                                                    },
                                                    onPreviewPage: function() {
                                                        return pool.id && (handlePreviewSupportesPage === null || handlePreviewSupportesPage === void 0 ? void 0 : handlePreviewSupportesPage(pool.id));
                                                    }
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Ainda n\xe3o h\xe1 apoiadores"
                                    })
                                ]
                            }),
                            !isGuest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivateAlbumSection, {
                                borderColor: fontColor,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "\xc1lbum de fotos"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    imgsPool.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                                        slidesPerView: "auto",
                                                        spaceBetween: 10,
                                                        grabCursor: true,
                                                        freeMode: true,
                                                        modules: [
                                                            swiper_esm/* FreeMode */.Rv
                                                        ],
                                                        children: imgsPool === null || imgsPool === void 0 ? void 0 : imgsPool.map(function(item) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                                style: {
                                                                    width: 184,
                                                                    height: 184
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "card",
                                                                    onClick: function() {},
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: item.url,
                                                                            alt: item.url
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaTrash */.Xm5, {
                                                                                onClick: function() {
                                                                                    return handleRemoveImg(item.id);
                                                                                },
                                                                                color: "#fff",
                                                                                size: 18
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }, item.id);
                                                        })
                                                    }),
                                                    imgsPool.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: preview_photo,
                                                        width: 100,
                                                        height: 96,
                                                        alt: "preview photo"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: function() {
                                                        return toggleModalImageCropper("album");
                                                    },
                                                    children: "Adicionar Fotos"
                                                })
                                            })
                                        ]
                                    })
                                })
                            }) : imgsPool.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicAlbumSection, {
                                pageSize: publicAlbumPages,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "title",
                                            children: "\xc1lbum de fotos"
                                        }),
                                        imgsPool.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                            style: {
                                                width: "100vw"
                                            },
                                            slidesPerView: "auto",
                                            onPaginationRender: function(_, pagination) {
                                                return setPublicAlbumPages(pagination.childElementCount);
                                            },
                                            spaceBetween: 30,
                                            modules: [
                                                swiper_esm/* Pagination */.tl
                                            ],
                                            pagination: true,
                                            children: imgsPool === null || imgsPool === void 0 ? void 0 : imgsPool.map(function(item) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                    style: {
                                                        width: "fit-content",
                                                        height: 400
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: item.url,
                                                            alt: item.url
                                                        })
                                                    })
                                                }, item.id);
                                            })
                                        }),
                                        imgsPool.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: preview_photo,
                                            width: 100,
                                            height: 96,
                                            alt: "preview photo"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageSection, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Mensagens Recebidas"
                                    }),
                                    messages.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                        pagination: {
                                            bulletActiveClass: "bulletActive"
                                        },
                                        slidesPerView: "auto",
                                        spaceBetween: 30,
                                        modules: [
                                            swiper_esm/* Pagination */.tl
                                        ],
                                        children: messages.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                style: {
                                                    width: 400,
                                                    marginBottom: 20
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "message",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: item.content
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                sanitizeDisplayName(item.name),
                                                                !isGuest && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Switch, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                    type: "checkbox",
                                                                                    id: item.id,
                                                                                    checked: item.visible,
                                                                                    onChange: function() {
                                                                                        return handleModerateMessage(item.id, item.visible);
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                    htmlFor: item.id,
                                                                                    children: "Aceitar"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                            children: "Aceitar"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, item.id);
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CentredSpan, {
                                        children: "Ainda n\xe3o h\xe1 mensagens"
                                    })
                                ]
                            }),
                            isGuest && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SendMessageSection, {
                                        fontColor: fontColor,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    children: "Nome:"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    placeholder: "Nome completo",
                                                    value: messageForm.name,
                                                    onChange: function(e) {
                                                        setMessageForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, messageForm), {
                                                            name: e.target.value
                                                        }));
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    children: "Deixe aqui sua mensagem:"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    placeholder: "As mensagens recebidas ser\xe3o exibidas aqui",
                                                    value: messageForm.content,
                                                    onChange: function(e) {
                                                        setMessageForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, messageForm), {
                                                            content: e.target.value
                                                        }));
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    onClick: function() {
                                                        pool.id && handlerSendMessage(pool.id);
                                                    },
                                                    children: "Enviar"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareSection, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: "Ajude a divulgar a campanha"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    onClick: function() {
                                                        return handlerShareData();
                                                    },
                                                    children: "Compartilhar"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                style: {
                                    overflow: "hidden",
                                    margin: "8rem 0"
                                },
                                children: isGuest && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentSecurity/* default */.Z, {
                                    color: newBackGroundColor !== "#fff6e8" ? distance < similarityThreshold && isGuest ? distance < similarityThreshold ? headerFontColor : headerBgColor : isGuest ? headerBgColor : headerFontColor : "#174F68"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                                bgColor: newBackGroundColor,
                                imageURL: footerBgImage || default_footer_bg.src,
                                mobileCover: footerBgImage || default_footer_mobile_bg.src,
                                children: !isGuest && /*#__PURE__*/ (0,jsx_runtime.jsx)(InsertImageButton, {
                                    onClick: function() {
                                        return toggleModalImageCropper("footer");
                                    },
                                    label: "Alterar imagem de rodap\xe9",
                                    arrowPosition: "down"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                        style: {
                            marginBottom: submit && !isGuest ? 70 : 0
                        },
                        bgColor: getSvgColor,
                        fontColor: distance < similarityThreshold && isGuest ? distance < similarityThreshold ? headerFontColor : headerBgColor : isGuest ? headerBgColor : headerFontColor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoItems, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/",
                                        onClick: function(e) {
                                            e.preventDefault();
                                            forceNavigation("/");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: distance < similarityThreshold ? "/Logo.svg" : "/Logo-white.svg",
                                            height: 60,
                                            alt: "logo-white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "web-copyright",
                                        children: [
                                            "\xa9 ",
                                            year,
                                            " - Todos os direitos reservados."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mobile-copyright",
                                        children: [
                                            "\xa9 ",
                                            year,
                                            " - Todos os direitos reservados."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CenterLinks, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileInstaLogo, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: socialNetwork.map(function(param, index) {
                                                var icon = param.icon, url = param.url;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    style: {
                                                        listStyle: "none",
                                                        cursor: "pointer"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        href: url,
                                                        style: {
                                                            display: "flex",
                                                            textDecoration: "none"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaInstagram */.Zf_, {
                                                                size: 25,
                                                                color: distance < similarityThreshold && isGuest ? distance < similarityThreshold ? headerFontColor : headerBgColor : isGuest ? headerBgColor : headerFontColor
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginLeft: ".5rem",
                                                                    marginTop: ".2rem",
                                                                    color: distance < similarityThreshold && isGuest ? distance < similarityThreshold ? headerFontColor : headerBgColor : isGuest ? headerBgColor : headerFontColor,
                                                                    cursor: "pointer",
                                                                    fontSize: "16px",
                                                                    fontFamily: "Nunito"
                                                                },
                                                                children: "Instagram"
                                                            })
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/report/".concat(pool.slug),
                                        onClick: function(e) {
                                            e.preventDefault();
                                            forceNavigation("/report/".concat(pool.slug));
                                        },
                                        style: {
                                            textDecoration: "none",
                                            color: "white"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Den\xfancia"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/termos-e-condicoes",
                                        onClick: function(e) {
                                            e.preventDefault();
                                            forceNavigation("/termos-e-condicoes");
                                        },
                                        style: {
                                            textDecoration: "none",
                                            color: "white"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Termos de uso"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/privacy-policy",
                                        onClick: function(e) {
                                            e.preventDefault();
                                            forceNavigation("/privacy-policy");
                                        },
                                        style: {
                                            textDecoration: "none",
                                            color: "white"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Pol\xedtica de privacidade"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InstaLogo, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: socialNetwork.map(function(param, index) {
                                        var icon = param.icon, url = param.url;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                href: url,
                                                style: {
                                                    display: "flex",
                                                    textDecoration: "none"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaInstagram */.Zf_, {
                                                        size: 25,
                                                        color: distance < similarityThreshold && isGuest ? distance < similarityThreshold ? headerFontColor : headerBgColor : isGuest ? headerBgColor : headerFontColor
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        style: {
                                                            marginLeft: ".5rem",
                                                            marginTop: ".2rem",
                                                            color: distance < similarityThreshold && isGuest ? distance < similarityThreshold ? headerFontColor : headerBgColor : isGuest ? headerBgColor : headerFontColor,
                                                            cursor: "pointer",
                                                            fontSize: "16px",
                                                            fontFamily: "Nunito"
                                                        },
                                                        children: "Instagram"
                                                    })
                                                ]
                                            })
                                        }, index);
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            !isGuest && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitContainer, {
                style: {
                    bottom: !submit ? "-7rem" : 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: mode === "edit" ? "Salvar altera\xe7\xf5es?" : "Ol\xe1! J\xe1 terminou de personalizar tudo?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: mode === "edit" ? handlerEditPool : handlerPool,
                                    children: mode === "edit" ? "Sim" : "Criar vaquinha"
                                }),
                                mode === "edit" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    style: {
                                        marginLeft: "1rem",
                                        backgroundColor: "#174F68"
                                    },
                                    onClick: handlerResetPool,
                                    children: "Cancelar"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var pool = (PoolTemplate);


/***/ }),

/***/ 33207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ readSupporterPaymentRaw; },
/* harmony export */   "z": function() { return /* binding */ supporterPaymentViaLine; }
/* harmony export */ });
function pickString(v) {
    if (typeof v === "string") {
        var t = v.trim();
        return t || null;
    }
    if (typeof v === "number" && !Number.isNaN(v)) return String(v);
    return null;
}
function readNested(obj, keys) {
    if (!obj) return null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var k = _step.value;
            var s = pickString(obj[k]);
            if (s) return s;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function readSupporterPaymentRaw(item) {
    var r = item;
    var top = readNested(r, [
        "payment_method",
        "paymentMethod",
        "payment_type",
        "paymentType",
        "billing_type",
        "billingType",
        "forma_pagamento",
        "formaPagamento",
        "method", 
    ]);
    if (top) return top;
    var tx = r.transaction;
    if (tx && typeof tx === "object" && !Array.isArray(tx)) {
        var fromTx = readNested(tx, [
            "payment_method",
            "paymentMethod",
            "billing_type",
            "billingType",
            "type",
            "method", 
        ]);
        if (fromTx) return fromTx;
    }
    var purchase = r.purchase;
    if (purchase && typeof purchase === "object" && !Array.isArray(purchase)) {
        var fromPur = readNested(purchase, [
            "payment_method",
            "paymentMethod",
            "billing_type",
            "billingType",
            "method", 
        ]);
        if (fromPur) return fromPur;
    }
    var payment = r.payment;
    if (payment && typeof payment === "object" && !Array.isArray(payment)) {
        var p = payment;
        var fromPay = readNested(p, [
            "method",
            "type",
            "billing_type",
            "billingType",
            "payment_method",
            "paymentMethod"
        ]);
        if (fromPay) return fromPay;
    }
    return null;
}
function supporterPaymentViaLine(item) {
    var raw = readSupporterPaymentRaw(item);
    if (!raw) return null;
    var normalized = raw.trim().toLowerCase().replace(/-/g, "_");
    if (!normalized) return null;
    var label;
    if (normalized === "credit_card") label = "cart\xe3o de cr\xe9dito";
    else if (normalized === "pix") label = "pix";
    else if (normalized === "boleto") label = "boleto";
    else label = raw.trim();
    return "Via: ".concat(label);
}


/***/ })

}]);